import firebase, { apps, database } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/analytics";
import "firebase/storage";
import { REALDB_CONSTANT } from "../Constant/FirebaseConstant";
import * as XLSX from "xlsx";
import { NotifyEvenuefy } from "../3rdParty";
import { RegionData } from "../Constant/RegionData";
import { SectionData } from "../Constant/SectionData";

const firebaseConfig = {
  apiKey: "AIzaSyBBgAbHlaczfUI-X1aKaQFIre8b1O7sfW8",
  authDomain: "iijs-floorplan.firebaseapp.com",
  databaseURL: "https://iijs-floorplan-default-rtdb.firebaseio.com",
  projectId: "iijs-floorplan",
  storageBucket: "iijs-floorplan.appspot.com",
  messagingSenderId: "144359212350",
  appId: "1:144359212350:web:d734da9f4f6f933e89986f",
  measurementId: "G-4ZFBF8M91S",
};

firebase.initializeApp(firebaseConfig);

export const firebaseApp = firebase;

export const auth = firebase.auth();

export const firestore = firebase.firestore();

export const realDB = firebase.database();

export const analytics = firebase.analytics();

export const storage = firebase.storage();

export const logoutUser = () => {
  return auth.signOut();
};

export const GetSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.SellerBaseData).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.SellerBaseData)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Base Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetSingleSellerBaseData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.SellerBaseData}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Base Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetAllSellersStallData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.Sellersdata).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.Sellersdata)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Stall Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
export const GetSingleSellerStallData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Stall Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const UpdateSellerStallData = (sellerId, payload, user, syncWithEvenufy = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !payload) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }
      if (syncWithEvenufy) {
        const result = await NotifyEvenuefy.allocated(NotifyEvenuefy.SellersDataToNotifyData(payload))
        // console.log(result)
        if (result.code != 200) {
          throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
        }
      }
      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.update(payload);
      const _nodeRef = realDB.ref(
        `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
      );
      let _pa = {
        ...payload,
      };
      if (user) {
        _pa = {
          ..._pa,
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        };
      }
      delete _pa.stallData;
      await _nodeRef.update(_pa);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const DeleteSellersStallData = (sellerId, sectionId, user, syncWithEvenufy = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !sectionId) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }

      console.log("sellerId", sellerId)
      console.log("sectionId", sectionId)

      if (syncWithEvenufy) {
        const result = await NotifyEvenuefy.revoked(sellerId, sectionId)
        // console.log(result)
        if (result.code != 200) {
          throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
        }
      }

      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.remove();
      if (user) {
        const _nodeRef = realDB.ref(
          `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
        );
        _nodeRef.update({
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        });
      }
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const getDataForExcel = async () => {
  try {
    // Fetch base data with a limit
    const baseNodeRef = realDB.ref(`${REALDB_CONSTANT.SellerBaseData}`);
    const baseNodeDataSnapshot = await baseNodeRef.get();
    if (!baseNodeDataSnapshot.exists()) {
      console.warn("No base data found.");
      return;
    }
    const baseNodeData = Object.values(baseNodeDataSnapshot.val());

    // Fetch seller data with a limit
    const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}`);
    const nodeDataSnapshot = await nodeRef.get();
    const nodeData = nodeDataSnapshot.exists() ? Object.values(nodeDataSnapshot.val()) : [];

    // Transform seller data into a hash map for efficient lookup
    const nodeDataHash = nodeData.reduce((acc, seller) => {
      acc[seller.comapnyId] = seller;
      return acc;
    }, {});

    // Map and merge base and seller data
    const result = baseNodeData.map((base) => {
      // Extract and flatten admin data
      const { admin: adminData, region, section, ...baseDetails } = base;
      const flattenedAdminData = Object.fromEntries(
        Object.entries(adminData || {}).map(([key, value]) => [`Admin_${key}`, value])
      );

      // Fetch and flatten stall data if it exists
      const seller = nodeDataHash[base.comapnyId] || {};
      const stallsData = seller.stallData || {};
      const flattenedStallsData = Object.entries(stallsData).reduce((acc, [stallId, stall], index) => {
        const stallPrefix = `Stall${index + 1}_`;
        Object.entries(stall).forEach(([key, value]) => {
          // Only include keys that are not "section"
          if (!["section", "area"].includes(key)) {
            acc[`${stallPrefix}${key}`] = value;
          }
        });
        return acc;
      }, {});

      // Combine all data
      return {
        ...baseDetails,
        region: RegionData[region] || region,
        section: SectionData[section] || section,
        ...flattenedAdminData,
        ...flattenedStallsData,
      };
    });

    console.log(result);

    // Export to Excel
    const fileName = `IIJS_DATA_${Date.now()}.xlsx`;
    exportFile(result, "sheet1", fileName);
  } catch (error) {
    console.error("Error fetching or processing data:", error);
    throw error; // Rethrow for higher-level error handling
  }
};


export const exportFile = (
  data,
  sheetName,
  filename,
  headerOrdering = null
) => {
  try {
    console.log("exportFile");
    const wb = XLSX.utils.book_new();
    let wsAll = null;
    if (headerOrdering) {
      wsAll = XLSX.utils.json_to_sheet(data, {
        header: headerOrdering,
      });
    } else {
      wsAll = XLSX.utils.json_to_sheet(data);
    }
    XLSX.utils.book_append_sheet(wb, wsAll, sheetName);
    XLSX.writeFile(wb, filename);
  } catch (error) {
    console.error(error);
  }
};
window.getDataForExcel = getDataForExcel;

const newData = {
  "7000015159A": {
    "comapnyId": "7000015159A",
    "company_name": "C6 JEWELS PRIVATE LIMITED ",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009083A": {
    "comapnyId": "7000009083A",
    "company_name": "MUKTI GOLD PVT. LTD ",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006595A": {
    "comapnyId": "7000006595A",
    "company_name": "SHEETAL JEWELLERY HOUSE LLP ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
};

const data = {
  "7000077866": {
    "comapnyId": "7000077866",
    "company_name": "MAHENDRA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000052731": {
    "comapnyId": "7000052731",
    "company_name": "ENDORA INTERIORS",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009375": {
    "comapnyId": "7000009375",
    "company_name": "PACIO PREMIUM PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000083401": {
    "comapnyId": "7000083401",
    "company_name": "SHASHWAT ATELIERR LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000082995": {
    "comapnyId": "7000082995",
    "company_name": "SANGAM FINE JEWELLERY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000083362": {
    "comapnyId": "7000083362",
    "company_name": "SANGAM CHAINS AND GOLD LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000083745": {
    "comapnyId": "7000083745",
    "company_name": "SANGAM HOUSE OF JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000090714": {
    "comapnyId": "7000090714",
    "company_name": "DIAMOND DREAMS MANUFACTURING PVT LTD",
    "region": "region_7",
    "section": "sectionData_7",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099792": {
    "comapnyId": "7000099792",
    "company_name": "TSILIVI JEWELS PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009083": {
    "comapnyId": "7000009083",
    "company_name": "MUKTI GOLD PVT. LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 72,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053040": {
    "comapnyId": "7000053040",
    "company_name": "BHARTI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097812": {
    "comapnyId": "7000097812",
    "company_name": "UMI INTERIORS",
    "region": "region_1",
    "section": "sectionData_11",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080254": {
    "comapnyId": "7000080254",
    "company_name": "HARITSONS EARTHGEMS PRIVATE LIMITED",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098221": {
    "comapnyId": "7000098221",
    "company_name": "CIXCENT TECHNOLOGIES PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000035512": {
    "comapnyId": "7000035512",
    "company_name": "RTSHAH JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090301": {
    "comapnyId": "7000090301",
    "company_name": "TRIVENI INTERNATIONAL",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099123": {
    "comapnyId": "7000099123",
    "company_name": "LUXEGOLD JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000059640": {
    "comapnyId": "7000059640",
    "company_name": "ANANT JEWEL MART LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007129": {
    "comapnyId": "7000007129",
    "company_name": "MOHAR DIAMONDS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070197": {
    "comapnyId": "7000070197",
    "company_name": "PITRUCHHAYA BANGLES PVT LTD",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098047": {
    "comapnyId": "7000098047",
    "company_name": "IPHYGITAL TECHNOLOGIES PVT. LTD.",
    "region": "region_6",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000058212": {
    "comapnyId": "7000058212",
    "company_name": "JEWELS VALLEY",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080639": {
    "comapnyId": "7000080639",
    "company_name": "SHINE THE JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002970": {
    "comapnyId": "7000002970",
    "company_name": "VANDNA INTERNATIONAL",
    "region": "region_6",
    "section": "sectionData_11",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090918": {
    "comapnyId": "7000090918",
    "company_name": "SHREE RAMDOOT JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000037542": {
    "comapnyId": "7000037542",
    "company_name": "M R JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000051583": {
    "comapnyId": "7000051583",
    "company_name": "ORNAWARE FINESSE PRIVATE LIMITED",
    "region": "region_5",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069484": {
    "comapnyId": "7000069484",
    "company_name": "ROYAL DIAMOND JEWELLERY",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097637": {
    "comapnyId": "7000097637",
    "company_name": "BANTIYA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079701": {
    "comapnyId": "7000079701",
    "company_name": "SATURN BAGS",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000093078": {
    "comapnyId": "7000093078",
    "company_name": "AJUNNI JEWELRY LLP",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099502": {
    "comapnyId": "7000099502",
    "company_name": "SHREE KUNJ BIHARI JEWELLERS",
    "region": "region_5",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066745": {
    "comapnyId": "7000066745",
    "company_name": "ELDORA JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079708": {
    "comapnyId": "7000079708",
    "company_name": "TRILOKESH GEMS AND JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000094815": {
    "comapnyId": "7000094815",
    "company_name": "J PENCIL PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_11",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000015725": {
    "comapnyId": "7000015725",
    "company_name": "SMIT GEMS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000010714": {
    "comapnyId": "7000010714",
    "company_name": "PRAKASH GOLD PALACE (P) LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000057559": {
    "comapnyId": "7000057559",
    "company_name": "PORWAL PALACE",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000005852": {
    "comapnyId": "7000005852",
    "company_name": "TWARA DIAM",
    "region": "region_3",
    "section": "sectionData_10",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000008697": {
    "comapnyId": "7000008697",
    "company_name": "MRK JEWELS PRIVATE LIMITED ",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086412": {
    "comapnyId": "7000086412",
    "company_name": "SHRI R K ENGINEERING WORKS",
    "region": "region_6",
    "section": "sectionData_12",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000038536": {
    "comapnyId": "7000038536",
    "company_name": "J P EXPORT",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000089072": {
    "comapnyId": "7000089072",
    "company_name": "GLEVERA",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000013662": {
    "comapnyId": "7000013662",
    "company_name": "SAMKIT GEMS ",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000088986": {
    "comapnyId": "7000088986",
    "company_name": "THOMAS&JO PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000011566": {
    "comapnyId": "7000011566",
    "company_name": "R.V. AGRAWAL IMPEX PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087172": {
    "comapnyId": "7000087172",
    "company_name": "BRAND KETTLE PROJECTS LIMITED",
    "region": "region_6",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099540": {
    "comapnyId": "7000099540",
    "company_name": "S R MINT COLLECTION",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097286": {
    "comapnyId": "7000097286",
    "company_name": "ARUN CHAINS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098174": {
    "comapnyId": "7000098174",
    "company_name": "JAINAM JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053208": {
    "comapnyId": "7000053208",
    "company_name": "JEWELCO WINGS EXPORTS PVT LTD",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009168": {
    "comapnyId": "7000009168",
    "company_name": "A.B. GEMS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060816": {
    "comapnyId": "7000060816",
    "company_name": "REYONA JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098173": {
    "comapnyId": "7000098173",
    "company_name": "ANKJ DESIGNS LLP",
    "region": "region_5",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097803": {
    "comapnyId": "7000097803",
    "company_name": "VENICE DIA JEWEL PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090384": {
    "comapnyId": "7000090384",
    "company_name": "ISHTARA GEMS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000076431": {
    "comapnyId": "7000076431",
    "company_name": "INTERNATIONAL INSTITUTE OF GEMOLOGY SOUTH",
    "region": "region_1",
    "section": "sectionData_4",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000092032": {
    "comapnyId": "7000092032",
    "company_name": "BABU BHAI MOTI & CHAIN WALA",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087109": {
    "comapnyId": "7000087109",
    "company_name": "CHANDRALABH JEWELLERY",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099432": {
    "comapnyId": "7000099432",
    "company_name": "MANOJ JEWELLERS LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098097": {
    "comapnyId": "7000098097",
    "company_name": "KALPAVRIKSHA GEMS AND JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081070": {
    "comapnyId": "7000081070",
    "company_name": "ALPHA PROJECTS INTERNATIONAL",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000012201": {
    "comapnyId": "7000012201",
    "company_name": "SAHAJANAND TECHNOLOGIES  PVT LTD",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098864": {
    "comapnyId": "7000098864",
    "company_name": "CARBONSTAR DIAMONDS",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069978": {
    "comapnyId": "7000069978",
    "company_name": "MANN CHAINS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000027790": {
    "comapnyId": "7000027790",
    "company_name": "SRI MONDAL JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097757": {
    "comapnyId": "7000097757",
    "company_name": "RK &  SONS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000099083": {
    "comapnyId": "7000099083",
    "company_name": "SREE VENKATESWARA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000017336": {
    "comapnyId": "7000017336",
    "company_name": "M. SAKSHI INTERNATIONAL ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086835": {
    "comapnyId": "7000086835",
    "company_name": "DHARMI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098598": {
    "comapnyId": "7000098598",
    "company_name": "KASHVI EXPORTS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053126": {
    "comapnyId": "7000053126",
    "company_name": "JEWELS4U",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097597": {
    "comapnyId": "7000097597",
    "company_name": "H D SILVER MANSION",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081404": {
    "comapnyId": "7000081404",
    "company_name": "MANIBHADRA GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000071159": {
    "comapnyId": "7000071159",
    "company_name": "T R GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080746": {
    "comapnyId": "7000080746",
    "company_name": "STAR JEWEL HOUSE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066499": {
    "comapnyId": "7000066499",
    "company_name": "KATTAS GEMS & JEWELS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000052663": {
    "comapnyId": "7000052663",
    "company_name": "ROSHNI GOLD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097433": {
    "comapnyId": "7000097433",
    "company_name": "DAMASO RETAIL",
    "region": "region_1",
    "section": "sectionData_11",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003561": {
    "comapnyId": "7000003561",
    "company_name": "BLINGGG ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000050266": {
    "comapnyId": "7000050266",
    "company_name": "SHREE DEREWALA JEWELLERS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097608": {
    "comapnyId": "7000097608",
    "company_name": "SHRI COIMBATORE JEWELLERS INDIA PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000092829": {
    "comapnyId": "7000092829",
    "company_name": "ZM LIFESTYLE PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081917": {
    "comapnyId": "7000081917",
    "company_name": "JIAMI SILBER LLP",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000037694": {
    "comapnyId": "7000037694",
    "company_name": "CHHANDA JEWELLERS",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000008943": {
    "comapnyId": "7000008943",
    "company_name": "ONEX JUWELLS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000067257": {
    "comapnyId": "7000067257",
    "company_name": "MJR SILVER PVT LTD",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098862": {
    "comapnyId": "7000098862",
    "company_name": "H. M. BHAMA EXPORTS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000001350": {
    "comapnyId": "7000001350",
    "company_name": "VIR JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090971": {
    "comapnyId": "7000090971",
    "company_name": "AGR GOLD JEWELLERY LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090243": {
    "comapnyId": "7000090243",
    "company_name": "DATACARE SOFTTECH",
    "region": "region_3",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000073104": {
    "comapnyId": "7000073104",
    "company_name": "DIARAH JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090049": {
    "comapnyId": "7000090049",
    "company_name": "TN JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000012955": {
    "comapnyId": "7000012955",
    "company_name": "GANESH DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000094510": {
    "comapnyId": "7000094510",
    "company_name": "MEENAKSHI DIAMONDS LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090516": {
    "comapnyId": "7000090516",
    "company_name": "SHIVAM JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000098778": {
    "comapnyId": "7000098778",
    "company_name": "SHILPI IMPEX",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086923": {
    "comapnyId": "7000086923",
    "company_name": "MUKTI DIAMOND JEWELLERY",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007340": {
    "comapnyId": "7000007340",
    "company_name": "MIRA GEMS",
    "region": "region_3",
    "section": "sectionData_5",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007102": {
    "comapnyId": "7000007102",
    "company_name": "AADEY JEWELS PRIVATE LIMITED ",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013370": {
    "comapnyId": "7000013370",
    "company_name": "HRD DIAMOND INSTITUT E PVT LTD",
    "region": "region_2",
    "section": "sectionData_4",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000093073": {
    "comapnyId": "7000093073",
    "company_name": "NAVKAR GOLD PALACE",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080804": {
    "comapnyId": "7000080804",
    "company_name": "UTSARVA JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000004732": {
    "comapnyId": "7000004732",
    "company_name": "LEHAR GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097590": {
    "comapnyId": "7000097590",
    "company_name": "SHYAM JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000091612": {
    "comapnyId": "7000091612",
    "company_name": "N J JEWELLERS INDIA PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097275": {
    "comapnyId": "7000097275",
    "company_name": "NAVKAR GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097743": {
    "comapnyId": "7000097743",
    "company_name": "SHREE CHAINS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000058859": {
    "comapnyId": "7000058859",
    "company_name": "KUMKUM JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087144": {
    "comapnyId": "7000087144",
    "company_name": "JIVANI DIAMONDS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079803": {
    "comapnyId": "7000079803",
    "company_name": "ASK JEWELLERY",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053269": {
    "comapnyId": "7000053269",
    "company_name": "RATIH JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090385": {
    "comapnyId": "7000090385",
    "company_name": "MANJALLY JEWELLERY",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097897": {
    "comapnyId": "7000097897",
    "company_name": "M.R. JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090140": {
    "comapnyId": "7000090140",
    "company_name": "RAJ KRUPA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000001441": {
    "comapnyId": "7000001441",
    "company_name": "C N B DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079657": {
    "comapnyId": "7000079657",
    "company_name": "DIVI DIAMONDS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097629": {
    "comapnyId": "7000097629",
    "company_name": "VRAJ JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000012395": {
    "comapnyId": "7000012395",
    "company_name": "DHARAM EXPORT (INDIA) PVT LTD",
    "region": "region_3",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000083265": {
    "comapnyId": "7000083265",
    "company_name": "SUVIJITA JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090645": {
    "comapnyId": "7000090645",
    "company_name": "ARIHANT GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053102": {
    "comapnyId": "7000053102",
    "company_name": "ASHOK DIAMONDS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000097337": {
    "comapnyId": "7000097337",
    "company_name": "RMPM JEWEL INDUSTRY INDIA LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086846": {
    "comapnyId": "7000086846",
    "company_name": "TULSIYA JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090916": {
    "comapnyId": "7000090916",
    "company_name": "LUSTRELLA",
    "region": "region_7",
    "section": "sectionData_7",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000052450": {
    "comapnyId": "7000052450",
    "company_name": "HEMNAV VENTURES PRIVATE LIMITED ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080281": {
    "comapnyId": "7000080281",
    "company_name": "SHEEN AI",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000010358": {
    "comapnyId": "7000010358",
    "company_name": "HARITHA AUTOMATION PVT. LTD ",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069641": {
    "comapnyId": "7000069641",
    "company_name": "ARHAM GEMS & JEWELS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052433": {
    "comapnyId": "7000052433",
    "company_name": "V360 TECHNETRONIC LLP",
    "region": "region_3",
    "section": "sectionData_11",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081315": {
    "comapnyId": "7000081315",
    "company_name": "LOYAL STRING INTERNATIONAL PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080559": {
    "comapnyId": "7000080559",
    "company_name": "RAJESH INDIA MANUFACTURING PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069529": {
    "comapnyId": "7000069529",
    "company_name": "SHREE RAPID TECHNOLOGIES ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000068353": {
    "comapnyId": "7000068353",
    "company_name": "A1 VISHAL TOOLS",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000053258": {
    "comapnyId": "7000053258",
    "company_name": "PARSHNATH BOXES",
    "region": "region_6",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000060985": {
    "comapnyId": "7000060985",
    "company_name": "J R LABELWALA AND CO",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000013110": {
    "comapnyId": "7000013110",
    "company_name": "CASCADE STAR INDIA PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079795": {
    "comapnyId": "7000079795",
    "company_name": "SINDHAV INDUSTRIES",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009464": {
    "comapnyId": "7000009464",
    "company_name": "NAVBHARAT CARBON CO. (BOMBAY)",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000003155": {
    "comapnyId": "7000003155",
    "company_name": "ANKITST EXIM INC ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000002258": {
    "comapnyId": "7000002258",
    "company_name": "P K TRADERS ",
    "region": "region_1",
    "section": "sectionData_11",
    "area": 54,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000048444": {
    "comapnyId": "7000048444",
    "company_name": "MANOHAR LAL AND SONS",
    "region": "region_4",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000078437": {
    "comapnyId": "7000078437",
    "company_name": "MILLENIA TECHNOLOGIES (I) PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066835": {
    "comapnyId": "7000066835",
    "company_name": "PRECISE PIERCING PRODUCTS INDIA LLP",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000007642": {
    "comapnyId": "7000007642",
    "company_name": "ASIAN LASER ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009270": {
    "comapnyId": "7000009270",
    "company_name": "PIERCING SYSTEMS INDIA PVT.  LTD.",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000067483": {
    "comapnyId": "7000067483",
    "company_name": "SPECTROVISION INTRUMENTS PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017380": {
    "comapnyId": "7000017380",
    "company_name": "D SOFT INFOTECH PVT LTD",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069866": {
    "comapnyId": "7000069866",
    "company_name": "MICROMAC INDUSTRIES PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000015237": {
    "comapnyId": "7000015237",
    "company_name": "SARTO ELECTRO EQUIPMENT PVT.LT D.",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076459": {
    "comapnyId": "7000076459",
    "company_name": "MAX POWER INDUCTION",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000077690": {
    "comapnyId": "7000077690",
    "company_name": "TECHNOCAST MACHINE AND TOOLS LLP",
    "region": "region_4",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000053155": {
    "comapnyId": "7000053155",
    "company_name": "AONE DIAMOND AIDS ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000089023": {
    "comapnyId": "7000089023",
    "company_name": "MAGICO PACKAGING PRIVATE LTD",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080945": {
    "comapnyId": "7000080945",
    "company_name": "HARIOM INDUSTRIES",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017488": {
    "comapnyId": "7000017488",
    "company_name": "FISCHER MEASUREMENT TECHNOLOGI ES (INDIA) PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000044375": {
    "comapnyId": "7000044375",
    "company_name": "SHAKTI ENTERPRISE ",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070170": {
    "comapnyId": "7000070170",
    "company_name": "WESTERN EQUIPMENTS AND ALLIED PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080620": {
    "comapnyId": "7000080620",
    "company_name": "LUCKY TRADERS",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000001902": {
    "comapnyId": "7000001902",
    "company_name": "JOHARI GEMS & TOOLS ",
    "region": "region_4",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079599": {
    "comapnyId": "7000079599",
    "company_name": "SHREE VAGHESHWARI ROLLING WORKS AND MANUFACTURING",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000006236": {
    "comapnyId": "7000006236",
    "company_name": "M M I SOFTWARES PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000048438": {
    "comapnyId": "7000048438",
    "company_name": "THE BOMBAY DISPLAY COMPANY",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 27,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017321": {
    "comapnyId": "7000017321",
    "company_name": "S.R. MEHTA & SONS ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000060616": {
    "comapnyId": "7000060616",
    "company_name": "SHREE RAJ MARKETING",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 27,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000060947": {
    "comapnyId": "7000060947",
    "company_name": "DT EXPORTS",
    "region": "region_6",
    "section": "sectionData_11",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080475": {
    "comapnyId": "7000080475",
    "company_name": "SHAPET INDUCTION PVT LTD",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009906": {
    "comapnyId": "7000009906",
    "company_name": "RANSA INC ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000065267": {
    "comapnyId": "7000065267",
    "company_name": "SIONIQ TECH PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000003177": {
    "comapnyId": "7000003177",
    "company_name": "DOIT INDUSTRIES LIMITED",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017323": {
    "comapnyId": "7000017323",
    "company_name": "GESSWEIN TRADING PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000004626": {
    "comapnyId": "7000004626",
    "company_name": "ASHLYN CHEMUNNOOR INSTRUMENTS  PVT LTD",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090419": {
    "comapnyId": "7000090419",
    "company_name": "SRS JEWELKON INDIA PVT LTD",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069955": {
    "comapnyId": "7000069955",
    "company_name": "ALPHA E BARCODE SOLUTIONS PVT LTD",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000004101": {
    "comapnyId": "7000004101",
    "company_name": "SACHI ",
    "region": "region_4",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070021": {
    "comapnyId": "7000070021",
    "company_name": "KARAT 24 PROJECTS",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076658": {
    "comapnyId": "7000076658",
    "company_name": "BLUESTONE TECH LABS PVT LTD ",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009167": {
    "comapnyId": "7000009167",
    "company_name": "ARIHANT MAXSELL TECHNOLOGIES PVT LTD",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017415": {
    "comapnyId": "7000017415",
    "company_name": "ACME INFOVISION SYSTEMS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000067133": {
    "comapnyId": "7000067133",
    "company_name": "S. P. ULTRASONIC",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000037828": {
    "comapnyId": "7000037828",
    "company_name": "KHUSHBOO NOVELTIES",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000060182": {
    "comapnyId": "7000060182",
    "company_name": "HINGLAJ MANUFACTURING",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076157": {
    "comapnyId": "7000076157",
    "company_name": "OROMAC",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000034346": {
    "comapnyId": "7000034346",
    "company_name": "DM INVENT PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_11",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069667": {
    "comapnyId": "7000069667",
    "company_name": "SUNNY MACHINERIES",
    "region": "region_3",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066398": {
    "comapnyId": "7000066398",
    "company_name": "INSTA LAXMI PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090302": {
    "comapnyId": "7000090302",
    "company_name": "NAMO SILVER",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000038020": {
    "comapnyId": "7000038020",
    "company_name": "SHREE SANTOSHI JEWELLERS LLP",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090426": {
    "comapnyId": "7000090426",
    "company_name": "JANVIDHI GOLD PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000001307": {
    "comapnyId": "7000001307",
    "company_name": "M.J. & SONS JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000063693": {
    "comapnyId": "7000063693",
    "company_name": "ARITZA GOLD PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000046257": {
    "comapnyId": "7000046257",
    "company_name": "MAASILVER HUB INDIA PVT LTD",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000005899": {
    "comapnyId": "7000005899",
    "company_name": "MAHESH CHAND JAIN & SONS  SARRAF PVT. LTD.",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075757": {
    "comapnyId": "7000075757",
    "company_name": "KANAKDHARA JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080026": {
    "comapnyId": "7000080026",
    "company_name": "GROWMORE VALUE PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002656": {
    "comapnyId": "7000002656",
    "company_name": "GORDHANDAS NANDKISHORE JEWELLERS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000016175": {
    "comapnyId": "7000016175",
    "company_name": "THE LALIT GEMS CO. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000005814": {
    "comapnyId": "7000005814",
    "company_name": "SHREE MANGAL ABHUSHAN PVT.LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080174": {
    "comapnyId": "7000080174",
    "company_name": "TANVI SILVER INDIA PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000012054": {
    "comapnyId": "7000012054",
    "company_name": "ORNAMENT CREATIONS ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000004702": {
    "comapnyId": "7000004702",
    "company_name": "BINNYS JEWELLERY PVT LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075734": {
    "comapnyId": "7000075734",
    "company_name": "ORO JEWELS",
    "region": "region_1",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000089933": {
    "comapnyId": "7000089933",
    "company_name": "INDIGO PRINTS",
    "region": "region_6",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066457": {
    "comapnyId": "7000066457",
    "company_name": "GREENLAB JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 54,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000081570": {
    "comapnyId": "7000081570",
    "company_name": "DVM AQUA GOLD PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003533": {
    "comapnyId": "7000003533",
    "company_name": "HARSH PRECIOUS METALS P. LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090227": {
    "comapnyId": "7000090227",
    "company_name": "DILIPS JEWEL HOUSE",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079819": {
    "comapnyId": "7000079819",
    "company_name": "CHUNILAL JEWEL",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000068394": {
    "comapnyId": "7000068394",
    "company_name": "DEV DIAMOND",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076858": {
    "comapnyId": "7000076858",
    "company_name": "AGCOLOR LLP",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090376": {
    "comapnyId": "7000090376",
    "company_name": "MUGAL ARTS & GEMS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000081029": {
    "comapnyId": "7000081029",
    "company_name": "SAMTA DIAMOND",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000013196": {
    "comapnyId": "7000013196",
    "company_name": "HARI GEMS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000057732": {
    "comapnyId": "7000057732",
    "company_name": "PURPLE JEWELS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075440": {
    "comapnyId": "7000075440",
    "company_name": "ISHI INDIA JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090363": {
    "comapnyId": "7000090363",
    "company_name": "SOJ INDUSTRIES PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 36,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000052820": {
    "comapnyId": "7000052820",
    "company_name": "BERRY GEMS GALLERY",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079018": {
    "comapnyId": "7000079018",
    "company_name": "MANSI LAB GROWN DIAMONDS",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090411": {
    "comapnyId": "7000090411",
    "company_name": "DUTTA ENTERPRISES",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000005738": {
    "comapnyId": "7000005738",
    "company_name": "MANAPPURAM JEWELLERS LIMITED ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000071266": {
    "comapnyId": "7000071266",
    "company_name": "S.B. KUNDANWALA",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000089980": {
    "comapnyId": "7000089980",
    "company_name": "V H GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090167": {
    "comapnyId": "7000090167",
    "company_name": "SHREE PRITI GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066325": {
    "comapnyId": "7000066325",
    "company_name": "MAHENDRA JEWEL",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002410": {
    "comapnyId": "7000002410",
    "company_name": "SWAGAT JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000037835": {
    "comapnyId": "7000037835",
    "company_name": "ARYA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075438": {
    "comapnyId": "7000075438",
    "company_name": "CHOUDHARY TRADERS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076267": {
    "comapnyId": "7000076267",
    "company_name": "HOUSE OF POLKI",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000053589": {
    "comapnyId": "7000053589",
    "company_name": "MEERA JEWELLERYHOUSE LLP",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000067044": {
    "comapnyId": "7000067044",
    "company_name": "SMARAN JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003941": {
    "comapnyId": "7000003941",
    "company_name": "V.D. JEWELLERS ",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070997": {
    "comapnyId": "7000070997",
    "company_name": "SHREE MOMAI KRUPA JEWELLERS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090264": {
    "comapnyId": "7000090264",
    "company_name": "VIMLACHAL JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007684": {
    "comapnyId": "7000007684",
    "company_name": "DHANLAXMI JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090085": {
    "comapnyId": "7000090085",
    "company_name": "BHAVYA GEMS AND JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000048511": {
    "comapnyId": "7000048511",
    "company_name": "PARAS JEWELS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080337": {
    "comapnyId": "7000080337",
    "company_name": "ELIGHT JEWELLERY",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002679": {
    "comapnyId": "7000002679",
    "company_name": "GLOW STAR",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000004334": {
    "comapnyId": "7000004334",
    "company_name": "REAL GEM IMPEX ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000006662": {
    "comapnyId": "7000006662",
    "company_name": "KROWN JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070044": {
    "comapnyId": "7000070044",
    "company_name": "AARYAHI GOLD PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069056": {
    "comapnyId": "7000069056",
    "company_name": "MIDAS GOLD AND PLATINUM",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075849": {
    "comapnyId": "7000075849",
    "company_name": "SOUTH INDIA JEWELLERS (CHENNAI) PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000027810": {
    "comapnyId": "7000027810",
    "company_name": "BHAGYA GOLD LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090168": {
    "comapnyId": "7000090168",
    "company_name": "KANHA GOLDS",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000004531": {
    "comapnyId": "7000004531",
    "company_name": "RAJESHKUMAR MOHANLAL ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000017057": {
    "comapnyId": "7000017057",
    "company_name": "BIKANERI JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000038426": {
    "comapnyId": "7000038426",
    "company_name": "S.P.SHAH & SONS JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076688": {
    "comapnyId": "7000076688",
    "company_name": "AADINATH JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075924": {
    "comapnyId": "7000075924",
    "company_name": "BHAGHIRATHHI JEWELLERS PRIVATE LIMITED",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000015411": {
    "comapnyId": "7000015411",
    "company_name": "SHASHVAT JEWELS PRIVATE    LIMITED",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000008980": {
    "comapnyId": "7000008980",
    "company_name": "J V BANGLES PVT.LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069774": {
    "comapnyId": "7000069774",
    "company_name": "MUDRA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086988": {
    "comapnyId": "7000086988",
    "company_name": "ARUNA JEWELLERY",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000050409": {
    "comapnyId": "7000050409",
    "company_name": "JAIPUR RATNA MANUFACTURING PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000038522": {
    "comapnyId": "7000038522",
    "company_name": "MANSUKHBHAI SAVJIBHAI DHANDHUKIYA",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066667": {
    "comapnyId": "7000066667",
    "company_name": "SWASTIK JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000067684": {
    "comapnyId": "7000067684",
    "company_name": "ANMOL JEWELL",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090296": {
    "comapnyId": "7000090296",
    "company_name": "V DANA JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069773": {
    "comapnyId": "7000069773",
    "company_name": "MERRY GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000087021": {
    "comapnyId": "7000087021",
    "company_name": "VINAYAK SILVER",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000037742": {
    "comapnyId": "7000037742",
    "company_name": "BAFNA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080391": {
    "comapnyId": "7000080391",
    "company_name": "KANYSNA JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000012137": {
    "comapnyId": "7000012137",
    "company_name": "SAAZ JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000052949": {
    "comapnyId": "7000052949",
    "company_name": "PADMAWATI GEMS AND JEWELLERY LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000011631": {
    "comapnyId": "7000011631",
    "company_name": "ADANI & CO ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007891": {
    "comapnyId": "7000007891",
    "company_name": "MERULIYA JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000074560": {
    "comapnyId": "7000074560",
    "company_name": "MOHAR GEMS AND JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080803": {
    "comapnyId": "7000080803",
    "company_name": "DESHNA CREATIONS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000068826": {
    "comapnyId": "7000068826",
    "company_name": "AANGI GEMS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000035666": {
    "comapnyId": "7000035666",
    "company_name": "ECO LIGHT DIAMOND",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079098": {
    "comapnyId": "7000079098",
    "company_name": "TIRUPATI GEMS & JEWELS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000061077": {
    "comapnyId": "7000061077",
    "company_name": "AMULYA JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090366": {
    "comapnyId": "7000090366",
    "company_name": "GOLDEN PARADISE",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000011862": {
    "comapnyId": "7000011862",
    "company_name": "ACTION GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075449": {
    "comapnyId": "7000075449",
    "company_name": "RAMBALRAAM CHAINSS PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079900": {
    "comapnyId": "7000079900",
    "company_name": "SHRADDHA CHAINS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000053541": {
    "comapnyId": "7000053541",
    "company_name": "SAMSAA",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000007785": {
    "comapnyId": "7000007785",
    "company_name": "TIBARUMAL RAMNIVAS GEMS  JEWELS & PEARLS",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000010781": {
    "comapnyId": "7000010781",
    "company_name": "ROMIL JEWELRY PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000089976": {
    "comapnyId": "7000089976",
    "company_name": "ELIVA JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000068497": {
    "comapnyId": "7000068497",
    "company_name": "S C JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000004181": {
    "comapnyId": "7000004181",
    "company_name": "VINAYAKA JEWELS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069904": {
    "comapnyId": "7000069904",
    "company_name": "SHREE PRAMUKH ORNAMENTS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000067584": {
    "comapnyId": "7000067584",
    "company_name": "SHREE MANIKUMAR JEWELLERS",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000088973": {
    "comapnyId": "7000088973",
    "company_name": "FOURSQUARE DIAMONDS",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000063227": {
    "comapnyId": "7000063227",
    "company_name": "MAA JEWELS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000000857": {
    "comapnyId": "7000000857",
    "company_name": "NAKSHATRA JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000005762": {
    "comapnyId": "7000005762",
    "company_name": "GOLDEN MOMENTS JEWELLERY ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000084477": {
    "comapnyId": "7000084477",
    "company_name": "S N AND SONS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000016852": {
    "comapnyId": "7000016852",
    "company_name": "VENKATESH JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000059472": {
    "comapnyId": "7000059472",
    "company_name": "HARI OM JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069884": {
    "comapnyId": "7000069884",
    "company_name": "TIARA DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090343": {
    "comapnyId": "7000090343",
    "company_name": "SIDDHI JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079424": {
    "comapnyId": "7000079424",
    "company_name": "SPARK JEWELLERS",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090047": {
    "comapnyId": "7000090047",
    "company_name": "AESAL JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069987": {
    "comapnyId": "7000069987",
    "company_name": "DEEP CREATION",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075642": {
    "comapnyId": "7000075642",
    "company_name": "DREAM GOLD ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079620": {
    "comapnyId": "7000079620",
    "company_name": "MAHARAJA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002963": {
    "comapnyId": "7000002963",
    "company_name": "PRAGATI GOLD PVT LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000004123": {
    "comapnyId": "7000004123",
    "company_name": "ILLUSION SOLITAIRE DIAMOND JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000002195": {
    "comapnyId": "7000002195",
    "company_name": "BHAIRAV GOLD PVT LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000057587": {
    "comapnyId": "7000057587",
    "company_name": "SANKALP CREATIONS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000008638": {
    "comapnyId": "7000008638",
    "company_name": "NAVYA GEMS AND JEWELS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090342": {
    "comapnyId": "7000090342",
    "company_name": "BASRA",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090345": {
    "comapnyId": "7000090345",
    "company_name": "V.K.JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009258": {
    "comapnyId": "7000009258",
    "company_name": "UMA ORNAMENTS",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000078571": {
    "comapnyId": "7000078571",
    "company_name": "NAVPAD GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075626": {
    "comapnyId": "7000075626",
    "company_name": "MARUTI JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000068390": {
    "comapnyId": "7000068390",
    "company_name": "DIA-MENSION LAB INDIA PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069764": {
    "comapnyId": "7000069764",
    "company_name": "ROSE GOLD JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080214": {
    "comapnyId": "7000080214",
    "company_name": "CHETAN CHAINS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066343": {
    "comapnyId": "7000066343",
    "company_name": "RUBIA JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000010096": {
    "comapnyId": "7000010096",
    "company_name": "MEGHA GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000076296": {
    "comapnyId": "7000076296",
    "company_name": "KALISTA CARAT",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090355": {
    "comapnyId": "7000090355",
    "company_name": "MIRARSH FINE JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080138": {
    "comapnyId": "7000080138",
    "company_name": "HARSHIT JEWELLERS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000084357": {
    "comapnyId": "7000084357",
    "company_name": "RAJENDRA JEWELLERY HOUSE ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066239": {
    "comapnyId": "7000066239",
    "company_name": "BHAGWAN BABU JEWELLERS PVT. LTD.",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079071": {
    "comapnyId": "7000079071",
    "company_name": "NAMRATA UNIQUE ART DESIGNS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000016887": {
    "comapnyId": "7000016887",
    "company_name": "KINU BABA JEWELLERY (INDIA) PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017627": {
    "comapnyId": "7000017627",
    "company_name": "ANSUL EXPORTS ",
    "region": "region_6",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075876": {
    "comapnyId": "7000075876",
    "company_name": "AASHI JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000026282": {
    "comapnyId": "7000026282",
    "company_name": "PLUTO JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000012855": {
    "comapnyId": "7000012855",
    "company_name": "RADHIKA JEWELSCRAFT PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000068513": {
    "comapnyId": "7000068513",
    "company_name": "SHRI KRISHNA JEWELS",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009937": {
    "comapnyId": "7000009937",
    "company_name": "AARYA24KT INDIA PVT.LTD ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080166": {
    "comapnyId": "7000080166",
    "company_name": "VGOLD INDIA PVT LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090196": {
    "comapnyId": "7000090196",
    "company_name": "AARADHYA JEWELLERY",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080057": {
    "comapnyId": "7000080057",
    "company_name": "KIFS FINSTOCK LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075828": {
    "comapnyId": "7000075828",
    "company_name": "RIANTI JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007933": {
    "comapnyId": "7000007933",
    "company_name": "DHANI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080287": {
    "comapnyId": "7000080287",
    "company_name": "RARE ELEMENT TRADING LLP",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000043226": {
    "comapnyId": "7000043226",
    "company_name": "JENISH JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000005872": {
    "comapnyId": "7000005872",
    "company_name": "REAL PEARLS (BUNTY MOTIWALA)",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000053468": {
    "comapnyId": "7000053468",
    "company_name": "SRUJAN JEWELLERS INDIA PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000085242": {
    "comapnyId": "7000085242",
    "company_name": "BANSI GOLD PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000067879": {
    "comapnyId": "7000067879",
    "company_name": "SHREYA ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090088": {
    "comapnyId": "7000090088",
    "company_name": "AMEZA JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007582": {
    "comapnyId": "7000007582",
    "company_name": "SIDDHI JEWELS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000017023": {
    "comapnyId": "7000017023",
    "company_name": "UTSSAV CZ GOLD JEWELS LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000038453": {
    "comapnyId": "7000038453",
    "company_name": "SUVARNAJYOTI CREATIONS LLP",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000012302": {
    "comapnyId": "7000012302",
    "company_name": "R R JEWELLERS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070088": {
    "comapnyId": "7000070088",
    "company_name": "GROVER JEWELLS LIMITED",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000014910": {
    "comapnyId": "7000014910",
    "company_name": "SARAFF SOLITAIRES ",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000089422": {
    "comapnyId": "7000089422",
    "company_name": "KALAVARNI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075841": {
    "comapnyId": "7000075841",
    "company_name": "ALLURE PEARLS AND JEWELS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075432": {
    "comapnyId": "7000075432",
    "company_name": "RAHI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079944": {
    "comapnyId": "7000079944",
    "company_name": "RAMESH JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000000451": {
    "comapnyId": "7000000451",
    "company_name": "S.P. GOLD MINE PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007425": {
    "comapnyId": "7000007425",
    "company_name": "RAJYASH JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000057564": {
    "comapnyId": "7000057564",
    "company_name": "SHILPA DIAMONDS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000068085": {
    "comapnyId": "7000068085",
    "company_name": "ANOKHI ORNAMENTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080158": {
    "comapnyId": "7000080158",
    "company_name": "BHUMI CHAINS PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070620": {
    "comapnyId": "7000070620",
    "company_name": "SUVARNA LABDHI JEWEL LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079928": {
    "comapnyId": "7000079928",
    "company_name": "PADMINI JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070754": {
    "comapnyId": "7000070754",
    "company_name": "M B DEESIGNS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075802": {
    "comapnyId": "7000075802",
    "company_name": "RJS JEWELLERS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075511": {
    "comapnyId": "7000075511",
    "company_name": "ROYAL CREATIONS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079674": {
    "comapnyId": "7000079674",
    "company_name": "IMAGE ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087065": {
    "comapnyId": "7000087065",
    "company_name": "MNM JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000015068": {
    "comapnyId": "7000015068",
    "company_name": "HARSH JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000086998": {
    "comapnyId": "7000086998",
    "company_name": "MIDISA JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000012863": {
    "comapnyId": "7000012863",
    "company_name": "RUCHI EXPORTS",
    "region": "region_3",
    "section": "sectionData_10",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000038476": {
    "comapnyId": "7000038476",
    "company_name": "TEN X DIAMONDS SPOT",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066702": {
    "comapnyId": "7000066702",
    "company_name": "D N JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070782": {
    "comapnyId": "7000070782",
    "company_name": "L K CHAINS AND JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000060717": {
    "comapnyId": "7000060717",
    "company_name": "TANVI ETERNALS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 12,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069624": {
    "comapnyId": "7000069624",
    "company_name": "BHAKTI JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000087016": {
    "comapnyId": "7000087016",
    "company_name": "SRI BANSILAL BASESHWARLAL PEARLS DEALERS AND JEWELLERS",
    "region": "region_1",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000087607": {
    "comapnyId": "7000087607",
    "company_name": "SAHAJANAND JEWELS",
    "region": "region_3",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000089966": {
    "comapnyId": "7000089966",
    "company_name": "PRAKASH JEWELLERY MART PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079603": {
    "comapnyId": "7000079603",
    "company_name": "JIRAWALA GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000078390": {
    "comapnyId": "7000078390",
    "company_name": "CARATREE DIAMONDS LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000064234": {
    "comapnyId": "7000064234",
    "company_name": "RRJ ENTERPRISE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075543": {
    "comapnyId": "7000075543",
    "company_name": "MIDAS BANGLES",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000007346": {
    "comapnyId": "7000007346",
    "company_name": "UMANG JEWELS ",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000084261": {
    "comapnyId": "7000084261",
    "company_name": "EKAIVA JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000061320": {
    "comapnyId": "7000061320",
    "company_name": "GALAXY DIAMONDS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080205": {
    "comapnyId": "7000080205",
    "company_name": "DHANRAJ PRECIOUS METALS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000067498": {
    "comapnyId": "7000067498",
    "company_name": "NAKSHATRA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070850": {
    "comapnyId": "7000070850",
    "company_name": "DIYAMA JEWELS",
    "region": "region_1",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070694": {
    "comapnyId": "7000070694",
    "company_name": "ASTHA JEWELS & ORNAMENTS LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000010325": {
    "comapnyId": "7000010325",
    "company_name": "JINEET GEMS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000087307": {
    "comapnyId": "7000087307",
    "company_name": "DEVARSH GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080562": {
    "comapnyId": "7000080562",
    "company_name": "CZAR DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000081083": {
    "comapnyId": "7000081083",
    "company_name": "KALINDEE JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066893": {
    "comapnyId": "7000066893",
    "company_name": "ILA CREATION PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000011974": {
    "comapnyId": "7000011974",
    "company_name": "RAMNARAYAN & COMPANY",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000050277": {
    "comapnyId": "7000050277",
    "company_name": "FAB ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087031": {
    "comapnyId": "7000087031",
    "company_name": "VRINDAS",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000059355": {
    "comapnyId": "7000059355",
    "company_name": "SHUBHAM JEWELLERS CHENNAI PRIVATE LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000059559": {
    "comapnyId": "7000059559",
    "company_name": "GITA JEWELS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000090084": {
    "comapnyId": "7000090084",
    "company_name": "MAK JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090105": {
    "comapnyId": "7000090105",
    "company_name": "CORAL GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087215": {
    "comapnyId": "7000087215",
    "company_name": "SOLARIS JEWELS",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000037442": {
    "comapnyId": "7000037442",
    "company_name": "VIJAY JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000006713": {
    "comapnyId": "7000006713",
    "company_name": "AUGMONT ENTERPRISES PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_5",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000066620": {
    "comapnyId": "7000066620",
    "company_name": "SHREE LAXMI JEWELLERY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090150": {
    "comapnyId": "7000090150",
    "company_name": "SIYONA NX",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080366": {
    "comapnyId": "7000080366",
    "company_name": "SHIVAM ORNAMENTS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000089942": {
    "comapnyId": "7000089942",
    "company_name": "SIVEN JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066108": {
    "comapnyId": "7000066108",
    "company_name": "SWARNLAXMI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069501": {
    "comapnyId": "7000069501",
    "company_name": "DIAMOND TRADE CENTRE LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087866": {
    "comapnyId": "7000087866",
    "company_name": "VINAYAK GOLD PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075879": {
    "comapnyId": "7000075879",
    "company_name": "P. K. GEMS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000069549": {
    "comapnyId": "7000069549",
    "company_name": "SIDDHARTH ORNAMENTS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090020": {
    "comapnyId": "7000090020",
    "company_name": "WHITE LOTUS JEWELLERY",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000006116": {
    "comapnyId": "7000006116",
    "company_name": "JMD JEWELS ",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000013097": {
    "comapnyId": "7000013097",
    "company_name": "VIJAYRAJ JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000060465": {
    "comapnyId": "7000060465",
    "company_name": "ATMIYA JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076656": {
    "comapnyId": "7000076656",
    "company_name": "GEMMECO",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000077454": {
    "comapnyId": "7000077454",
    "company_name": "GOVARDHANNATH JEWELERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090180": {
    "comapnyId": "7000090180",
    "company_name": "PINA JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000015159": {
    "comapnyId": "7000015159",
    "company_name": "C6 JEWELS PRIVATE LIMITED ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000075066": {
    "comapnyId": "7000075066",
    "company_name": "C6 LABGROWN DIAMONDS LLP",
    "region": "region_3",
    "section": "sectionData_5",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000072865": {
    "comapnyId": "7000072865",
    "company_name": "PALM ORNA PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000071274": {
    "comapnyId": "7000071274",
    "company_name": "KRIZORA CREATIONS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075967": {
    "comapnyId": "7000075967",
    "company_name": "DESIGN ESCLUSIVO JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000059611": {
    "comapnyId": "7000059611",
    "company_name": "STRIBRNY CREATIONS LLP",
    "region": "region_5",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000006777": {
    "comapnyId": "7000006777",
    "company_name": "VV SILVER PALACE PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_3",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000071160": {
    "comapnyId": "7000071160",
    "company_name": "DHC GEM LAB AND INSTITUTE PVT LTD",
    "region": "region_1",
    "section": "sectionData_4",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000079692": {
    "comapnyId": "7000079692",
    "company_name": "N R GOLD LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000050651": {
    "comapnyId": "7000050651",
    "company_name": "JAI BHAIRAVA GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066165": {
    "comapnyId": "7000066165",
    "company_name": "R. C. JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081019": {
    "comapnyId": "7000081019",
    "company_name": "ROSE DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075483": {
    "comapnyId": "7000075483",
    "company_name": "DISHA ORNAMENTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000076568": {
    "comapnyId": "7000076568",
    "company_name": "BALAJI JEWELTRENDS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000090037": {
    "comapnyId": "7000090037",
    "company_name": "LAXMI GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075371": {
    "comapnyId": "7000075371",
    "company_name": "GAYATRI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000001396": {
    "comapnyId": "7000001396",
    "company_name": "CHETAN JEWELLERY ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000078896": {
    "comapnyId": "7000078896",
    "company_name": "NAKODA JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075832": {
    "comapnyId": "7000075832",
    "company_name": "D M GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000006019": {
    "comapnyId": "7000006019",
    "company_name": "DISHA ORNAMENTS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000089047": {
    "comapnyId": "7000089047",
    "company_name": "SHASAN JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000047492": {
    "comapnyId": "7000047492",
    "company_name": "ARAV JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080478": {
    "comapnyId": "7000080478",
    "company_name": "PRAYOM GLOBAL PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000047881": {
    "comapnyId": "7000047881",
    "company_name": "BLOSSOM JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070137": {
    "comapnyId": "7000070137",
    "company_name": "JAYAMBE JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000046255": {
    "comapnyId": "7000046255",
    "company_name": "PALM JEWELS LTD.",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070033": {
    "comapnyId": "7000070033",
    "company_name": "SHIVAM JEWELLERS",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000070447": {
    "comapnyId": "7000070447",
    "company_name": "V M AND SONS JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000087244": {
    "comapnyId": "7000087244",
    "company_name": "SAMRUDDHI ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000083121": {
    "comapnyId": "7000083121",
    "company_name": "SAVI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081991": {
    "comapnyId": "7000081991",
    "company_name": "CELEBRATION GEMS AND JEWELLERY",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000081994": {
    "comapnyId": "7000081994",
    "company_name": "VIRAZE JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000061072": {
    "comapnyId": "7000061072",
    "company_name": "SWARN SHREE CHAIN",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000002837": {
    "comapnyId": "7000002837",
    "company_name": "GEMCRAFT",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000076015": {
    "comapnyId": "7000076015",
    "company_name": "SPARSH GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066322": {
    "comapnyId": "7000066322",
    "company_name": "RB JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000080141": {
    "comapnyId": "7000080141",
    "company_name": "SHALINI JEWELS EXPORT",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000080115": {
    "comapnyId": "7000080115",
    "company_name": "MILAN GOLD PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000086814": {
    "comapnyId": "7000086814",
    "company_name": "KHETPAL GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000072657": {
    "comapnyId": "7000072657",
    "company_name": "DULICHAND BAJRANGLAL JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000066627": {
    "comapnyId": "7000066627",
    "company_name": "SKY GEMS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000005531": {
    "comapnyId": "7000005531",
    "company_name": "K.K. GEMS TRADING COMPANY ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000087040": {
    "comapnyId": "7000087040",
    "company_name": "PRIME GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000089065": {
    "comapnyId": "7000089065",
    "company_name": "UNNATI DIAMOND JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000059156": {
    "comapnyId": "7000059156",
    "company_name": "N. J. ARTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000086978": {
    "comapnyId": "7000086978",
    "company_name": "RHYTHM ART JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000061275": {
    "comapnyId": "7000061275",
    "company_name": "SHUBHAM JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000034767": {
    "comapnyId": "7000034767",
    "company_name": "UNITED PMR INC",
    "region": "region_7",
    "section": "sectionData_13",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000081918": {
    "comapnyId": "7000081918",
    "company_name": "CREATIONS GEMS AND JEWELLERY PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000058097": {
    "comapnyId": "7000058097",
    "company_name": "SHREE CHINTAMANI ORNA",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069746": {
    "comapnyId": "7000069746",
    "company_name": "SRI SHUBHAM JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006991": {
    "comapnyId": "7000006991",
    "company_name": "SHRI RISHABH JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037282": {
    "comapnyId": "7000037282",
    "company_name": "SMR JEWELS LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000253": {
    "comapnyId": "7000000253",
    "company_name": "FILO DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004598": {
    "comapnyId": "7000004598",
    "company_name": "SUNBERA EXPORTS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057304": {
    "comapnyId": "7000057304",
    "company_name": "ASHTALAXMI JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080212": {
    "comapnyId": "7000080212",
    "company_name": "GOLDIE JEWELS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004419": {
    "comapnyId": "7000004419",
    "company_name": "J.P. ENTERPRISE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075609": {
    "comapnyId": "7000075609",
    "company_name": "SHRI BANU DIAMOND",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080248": {
    "comapnyId": "7000080248",
    "company_name": "7R JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015065": {
    "comapnyId": "7000015065",
    "company_name": "SANGHI JEWELLERS PVT. LTD ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079757": {
    "comapnyId": "7000079757",
    "company_name": "STELLAR CREATIONS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009643": {
    "comapnyId": "7000009643",
    "company_name": "R B JEWELS AND GOLD LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070145": {
    "comapnyId": "7000070145",
    "company_name": "KENSTAR",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001542": {
    "comapnyId": "7000001542",
    "company_name": "EMERALD JEWEL INDUSTRY INDIA  LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080335": {
    "comapnyId": "7000080335",
    "company_name": "SHREE NATH JEWELS",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061140": {
    "comapnyId": "7000061140",
    "company_name": "SWARN JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016990": {
    "comapnyId": "7000016990",
    "company_name": "AKS JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013023": {
    "comapnyId": "7000013023",
    "company_name": "SONI SHAILESH NANALAL JEWELLERS PVT. LTD. ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038360": {
    "comapnyId": "7000038360",
    "company_name": "SANKET JEWELLERS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066476": {
    "comapnyId": "7000066476",
    "company_name": "MAHAVEER JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051909": {
    "comapnyId": "7000051909",
    "company_name": "SHASHWAT ORNAMENTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009932": {
    "comapnyId": "7000009932",
    "company_name": "VAJRA JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075548": {
    "comapnyId": "7000075548",
    "company_name": "DASHRATH GOLD ART PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000054325": {
    "comapnyId": "7000054325",
    "company_name": "GOLDEN CARAT PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004802": {
    "comapnyId": "7000004802",
    "company_name": "PATEL GEMS AND JEWELLRY",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000077016": {
    "comapnyId": "7000077016",
    "company_name": "MEERA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003194": {
    "comapnyId": "7000003194",
    "company_name": "PRATAP JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007759": {
    "comapnyId": "7000007759",
    "company_name": "M. MEHTA SONS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070360": {
    "comapnyId": "7000070360",
    "company_name": "SHREEYASH JEWELLERS (INDIA) PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005760": {
    "comapnyId": "7000005760",
    "company_name": "MUNOT ORNAMENTS ANNEX LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000106": {
    "comapnyId": "7000000106",
    "company_name": "BONITAS JEWELS PVT.L TD.",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010090": {
    "comapnyId": "7000010090",
    "company_name": "SRI NAVDURGA GEMS AND JEWELS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000067339": {
    "comapnyId": "7000067339",
    "company_name": "PNR MAHALAKSHMI JEWELLERY PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047197": {
    "comapnyId": "7000047197",
    "company_name": "CHARBHUJA JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061087": {
    "comapnyId": "7000061087",
    "company_name": "KALAVATHI JEWELLERSS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003928": {
    "comapnyId": "7000003928",
    "company_name": "H.M.T. ORNAMENT ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068072": {
    "comapnyId": "7000068072",
    "company_name": "AMYRAH CREATIONS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052707": {
    "comapnyId": "7000052707",
    "company_name": "MODI ORNAMENTS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000067575": {
    "comapnyId": "7000067575",
    "company_name": "STAR JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008650": {
    "comapnyId": "7000008650",
    "company_name": "SOUTH INDIA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009896": {
    "comapnyId": "7000009896",
    "company_name": "KUSHAL GEMS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000054321": {
    "comapnyId": "7000054321",
    "company_name": "RADHIKA CHAINS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059817": {
    "comapnyId": "7000059817",
    "company_name": "K. RAJ ORNAMENTS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005327": {
    "comapnyId": "7000005327",
    "company_name": "VAMA JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004111": {
    "comapnyId": "7000004111",
    "company_name": "SHREE RAGHAV EXPORTS ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038034": {
    "comapnyId": "7000038034",
    "company_name": "ARTS N JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061153": {
    "comapnyId": "7000061153",
    "company_name": "ALPHA KOSMIK DESIGNS LLP",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005717": {
    "comapnyId": "7000005717",
    "company_name": "MATUSHREE GOLD LLP ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008616": {
    "comapnyId": "7000008616",
    "company_name": "BEERA JEWELLERS",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007114": {
    "comapnyId": "7000007114",
    "company_name": "BANSIDHAR JEWELLERS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017203": {
    "comapnyId": "7000017203",
    "company_name": "RAMNIKLAL & SONS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014630": {
    "comapnyId": "7000014630",
    "company_name": "BILALA JEWELLERS ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066435": {
    "comapnyId": "7000066435",
    "company_name": "R. C. JAIN",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017389": {
    "comapnyId": "7000017389",
    "company_name": "R.K. INTERNATIONALS ",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000630": {
    "comapnyId": "7000000630",
    "company_name": "MOHANLAL JEWELLERS PRIVATE LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057641": {
    "comapnyId": "7000057641",
    "company_name": "KAMAKHYA JEWELS LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070574": {
    "comapnyId": "7000070574",
    "company_name": "AIRAVATA HERITAGE JEWELLERY",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005211": {
    "comapnyId": "7000005211",
    "company_name": "ARIANNA JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060759": {
    "comapnyId": "7000060759",
    "company_name": "MEET GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005993": {
    "comapnyId": "7000005993",
    "company_name": "SHRIPATI GOLD ORNAMENTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017020": {
    "comapnyId": "7000017020",
    "company_name": "RBZ JEWELLERS LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052389": {
    "comapnyId": "7000052389",
    "company_name": "EFFULGENT JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053113": {
    "comapnyId": "7000053113",
    "company_name": "J J J JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078979": {
    "comapnyId": "7000078979",
    "company_name": "RATHOD GOLD AND DIAMOND PRIVATE LIMITE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000060808": {
    "comapnyId": "7000060808",
    "company_name": "P D SONI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049853": {
    "comapnyId": "7000049853",
    "company_name": "MANISH BHINDI JEWELS",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017199": {
    "comapnyId": "7000017199",
    "company_name": "CREATIVE JEWEL ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007124": {
    "comapnyId": "7000007124",
    "company_name": "RAJ ORNAMENTS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057763": {
    "comapnyId": "7000057763",
    "company_name": "VESARA JEWELS PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069908": {
    "comapnyId": "7000069908",
    "company_name": "MTJ WORLD INDIA PVT LTD",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000027915": {
    "comapnyId": "7000027915",
    "company_name": "RK DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017120": {
    "comapnyId": "7000017120",
    "company_name": "ANMOL JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049846": {
    "comapnyId": "7000049846",
    "company_name": "NAVKAR GOLD PALACE LLP",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016415": {
    "comapnyId": "7000016415",
    "company_name": "V. N. EXPORTS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057359": {
    "comapnyId": "7000057359",
    "company_name": "ANJALI LABTECH LIMITED",
    "region": "region_3",
    "section": "sectionData_5",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063654": {
    "comapnyId": "7000063654",
    "company_name": "TULSI GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080203": {
    "comapnyId": "7000080203",
    "company_name": "RADHE DIAM GEMS AND JEWELLERY",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008395": {
    "comapnyId": "7000008395",
    "company_name": "MEENAKSHI JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013115": {
    "comapnyId": "7000013115",
    "company_name": "S.A. JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008816": {
    "comapnyId": "7000008816",
    "company_name": "AB JEWELS PRIVATE LIMITED ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001975": {
    "comapnyId": "7000001975",
    "company_name": "VIPUL JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052722": {
    "comapnyId": "7000052722",
    "company_name": "FUSION JEWELS INDIA",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015242": {
    "comapnyId": "7000015242",
    "company_name": "SHUBH DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066843": {
    "comapnyId": "7000066843",
    "company_name": "J . T . JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037733": {
    "comapnyId": "7000037733",
    "company_name": "AAROHI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044101": {
    "comapnyId": "7000044101",
    "company_name": "N M KAREL & SONS PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017006": {
    "comapnyId": "7000017006",
    "company_name": "GIA INDIA LABORATORY PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_4",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070678": {
    "comapnyId": "7000070678",
    "company_name": "SRI DURGA GEMS & JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059226": {
    "comapnyId": "7000059226",
    "company_name": "GOKUL DIVAY JEWELLERS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070641": {
    "comapnyId": "7000070641",
    "company_name": "KJ S FEATHER TOUCH JEWELLERY PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063124": {
    "comapnyId": "7000063124",
    "company_name": "NITYAS GEMS AND JEWELLERY LIMITED",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000065055": {
    "comapnyId": "7000065055",
    "company_name": "GLITIANI",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003356": {
    "comapnyId": "7000003356",
    "company_name": "PRAVIN MOTIWALA ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012180": {
    "comapnyId": "7000012180",
    "company_name": "RD FINE JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051572": {
    "comapnyId": "7000051572",
    "company_name": "MUTHAJI & SONS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008173": {
    "comapnyId": "7000008173",
    "company_name": "TINASHE CREATION ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079864": {
    "comapnyId": "7000079864",
    "company_name": "HDJ JEWEL PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010916": {
    "comapnyId": "7000010916",
    "company_name": "SKY JEWELS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003210": {
    "comapnyId": "7000003210",
    "company_name": "SAKARIYA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008208": {
    "comapnyId": "7000008208",
    "company_name": "SPLURGE JEWELS LLP ",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079646": {
    "comapnyId": "7000079646",
    "company_name": "GOMTI JEWELS LLP",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007796": {
    "comapnyId": "7000007796",
    "company_name": "ASHOK JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000474": {
    "comapnyId": "7000000474",
    "company_name": "DEE BEE JEWELLERS ",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058500": {
    "comapnyId": "7000058500",
    "company_name": "TAHI JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015341": {
    "comapnyId": "7000015341",
    "company_name": "SHAH VANAJI KESAJI & CO. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006595": {
    "comapnyId": "7000006595",
    "company_name": "SHEETAL JEWELLERY HOUSE LLP ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000077542": {
    "comapnyId": "7000077542",
    "company_name": "SIYA ORO JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000027838": {
    "comapnyId": "7000027838",
    "company_name": "ADASTRA JEWELRY PVT. LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003529": {
    "comapnyId": "7000003529",
    "company_name": "HARSH JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068473": {
    "comapnyId": "7000068473",
    "company_name": "CELAVO",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004152": {
    "comapnyId": "7000004152",
    "company_name": "NIRMAL JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070269": {
    "comapnyId": "7000070269",
    "company_name": "B DIAMOND AND GOLD JEWELLERY PRIVATE L",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009345": {
    "comapnyId": "7000009345",
    "company_name": "SEJAL JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066444": {
    "comapnyId": "7000066444",
    "company_name": "MY ZAVERI BAZAAR PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080132": {
    "comapnyId": "7000080132",
    "company_name": "RISHITH JEWELLERS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005861": {
    "comapnyId": "7000005861",
    "company_name": "JAI GULAB DEV JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007815": {
    "comapnyId": "7000007815",
    "company_name": "SHUBH ORNAMENTS LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075993": {
    "comapnyId": "7000075993",
    "company_name": "KEDIA JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075762": {
    "comapnyId": "7000075762",
    "company_name": "SUJATA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016784": {
    "comapnyId": "7000016784",
    "company_name": "KANCHAN ANTIQUE GOLD JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001630": {
    "comapnyId": "7000001630",
    "company_name": "FINESTAR JEWELLERY AND  DIAMONDS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012582": {
    "comapnyId": "7000012582",
    "company_name": "RMC GEMS INDIA LIMITED ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075770": {
    "comapnyId": "7000075770",
    "company_name": "UNI DESIGN ELITE JEWELLERY PVT LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000045717": {
    "comapnyId": "7000045717",
    "company_name": "NITIN JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016509": {
    "comapnyId": "7000016509",
    "company_name": "VASUPATI JEWELLERS INDIA PVT.  LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038265": {
    "comapnyId": "7000038265",
    "company_name": "TAJ JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038320": {
    "comapnyId": "7000038320",
    "company_name": "ADITYA JEWELS INDIA LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079589": {
    "comapnyId": "7000079589",
    "company_name": "RATNA DESIGN PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057635": {
    "comapnyId": "7000057635",
    "company_name": "GANGA JAMUNA JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015546": {
    "comapnyId": "7000015546",
    "company_name": "SHREE RAJ JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007811": {
    "comapnyId": "7000007811",
    "company_name": "TEJ JEWELS PRIVATE LIMITED ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017208": {
    "comapnyId": "7000017208",
    "company_name": "G.M. GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080108": {
    "comapnyId": "7000080108",
    "company_name": "MARQUISE JEWELS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053087": {
    "comapnyId": "7000053087",
    "company_name": "SHREE DHAN VERSHA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053927": {
    "comapnyId": "7000053927",
    "company_name": "RAJENDRA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016023": {
    "comapnyId": "7000016023",
    "company_name": "SUPERGEMS JEWELLERY MFG. PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000673": {
    "comapnyId": "7000000673",
    "company_name": "SOVAN JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079806": {
    "comapnyId": "7000079806",
    "company_name": "AMBAJI JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009946": {
    "comapnyId": "7000009946",
    "company_name": "J K JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003777": {
    "comapnyId": "7000003777",
    "company_name": "INTERNATIONAL GEMMOLOGICAL INSTITUTE (INDIA) LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000051569": {
    "comapnyId": "7000051569",
    "company_name": "COLOUR JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069997": {
    "comapnyId": "7000069997",
    "company_name": "MERRIGOLD JEWELLERS",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011250": {
    "comapnyId": "7000011250",
    "company_name": "R K R GOLD PRIVATE LIMITED ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006090": {
    "comapnyId": "7000006090",
    "company_name": "G.P. JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003419": {
    "comapnyId": "7000003419",
    "company_name": "HVK JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079848": {
    "comapnyId": "7000079848",
    "company_name": "SHANTI JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037954": {
    "comapnyId": "7000037954",
    "company_name": "OPH JEWELLER ",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011831": {
    "comapnyId": "7000011831",
    "company_name": "BACHUBHAI ZAVERI",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066460": {
    "comapnyId": "7000066460",
    "company_name": "MK EXPORTS",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052668": {
    "comapnyId": "7000052668",
    "company_name": "RASI JEWEL TECH",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007277": {
    "comapnyId": "7000007277",
    "company_name": "KRISHNA BANGLES ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000062601": {
    "comapnyId": "7000062601",
    "company_name": "JEWELS  BY SEPHORA LLP",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008006": {
    "comapnyId": "7000008006",
    "company_name": "M.U. JEWELLERS PVT. LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037535": {
    "comapnyId": "7000037535",
    "company_name": "L STAR",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010410": {
    "comapnyId": "7000010410",
    "company_name": "PEACEMOON TRADERS",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014838": {
    "comapnyId": "7000014838",
    "company_name": "DEW DIAMONDS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004779": {
    "comapnyId": "7000004779",
    "company_name": "JEWEL GOLDI (INDIA)",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079860": {
    "comapnyId": "7000079860",
    "company_name": "RATANSHINE JEWELS PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003551": {
    "comapnyId": "7000003551",
    "company_name": "LILI STAR JEWELLERY",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000054188": {
    "comapnyId": "7000054188",
    "company_name": "RUMI JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011132": {
    "comapnyId": "7000011132",
    "company_name": "BHARATI JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001183": {
    "comapnyId": "7000001183",
    "company_name": "LALITH JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005484": {
    "comapnyId": "7000005484",
    "company_name": "K.G.K. CREATIONS (INDIA) PVT.  LTD.",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047726": {
    "comapnyId": "7000047726",
    "company_name": "VINATI JEWELLERS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038027": {
    "comapnyId": "7000038027",
    "company_name": "VIE 92 JEWELLERY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026283": {
    "comapnyId": "7000026283",
    "company_name": "MOHAN LAL NARAYAN DAS JEWELLERS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004831": {
    "comapnyId": "7000004831",
    "company_name": "JEWELEX INDIA PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044818": {
    "comapnyId": "7000044818",
    "company_name": "GOLDEN TOUCH ARTWARE  PVT. LTD. ",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016596": {
    "comapnyId": "7000016596",
    "company_name": "VINAYAK EXPORTS ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070660": {
    "comapnyId": "7000070660",
    "company_name": "CHANDIKA PEARLS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078533": {
    "comapnyId": "7000078533",
    "company_name": "SHRI VARAH JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015451": {
    "comapnyId": "7000015451",
    "company_name": "SHINESHILPI JEWELLERS PVT.LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051525": {
    "comapnyId": "7000051525",
    "company_name": "SHINESTONE DIAM LLP",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080137": {
    "comapnyId": "7000080137",
    "company_name": "EKTA GEMS AND JEWELS",
    "region": "region_1",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051050": {
    "comapnyId": "7000051050",
    "company_name": "SHREE BALAJI CHAIN & JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005248": {
    "comapnyId": "7000005248",
    "company_name": "JIGNA CREATIONS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016520": {
    "comapnyId": "7000016520",
    "company_name": "VEEKAY DIAMANTS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006975": {
    "comapnyId": "7000006975",
    "company_name": "NARAYAN GEMS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004155": {
    "comapnyId": "7000004155",
    "company_name": "ELVEE JEWELS PRIVATE LIMITED ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017042": {
    "comapnyId": "7000017042",
    "company_name": "GOKUL GEMS AND JEWELS PVT LTD ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079987": {
    "comapnyId": "7000079987",
    "company_name": "CIARA JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057595": {
    "comapnyId": "7000057595",
    "company_name": "VEER JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078469": {
    "comapnyId": "7000078469",
    "company_name": "LAXMI IMPERIAL PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000074564": {
    "comapnyId": "7000074564",
    "company_name": "NAKODA ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000011727": {
    "comapnyId": "7000011727",
    "company_name": "HIMANI DIAMOND ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000048633": {
    "comapnyId": "7000048633",
    "company_name": "SAAJ CREATIONS",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001918": {
    "comapnyId": "7000001918",
    "company_name": "SAINATH JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016838": {
    "comapnyId": "7000016838",
    "company_name": "HEMRATNA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015816": {
    "comapnyId": "7000015816",
    "company_name": "SRI PADMARAJ JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009135": {
    "comapnyId": "7000009135",
    "company_name": "MURARI EXPORTS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004566": {
    "comapnyId": "7000004566",
    "company_name": "STUTI JEWELS LLP ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051554": {
    "comapnyId": "7000051554",
    "company_name": "ROYAL GOLD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011439": {
    "comapnyId": "7000011439",
    "company_name": "SRI VENKATESHWARA JEWELLERS  ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002994": {
    "comapnyId": "7000002994",
    "company_name": "WHITE FIRE DIAMONDS INDIA  PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002178": {
    "comapnyId": "7000002178",
    "company_name": "MAHARAJA CHAINS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016956": {
    "comapnyId": "7000016956",
    "company_name": "ADITYA FINDINGS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009619": {
    "comapnyId": "7000009619",
    "company_name": "AMY JEWELLERY DESIGNERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004731": {
    "comapnyId": "7000004731",
    "company_name": "VAISHNAVI GEMS & JEWELS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016975": {
    "comapnyId": "7000016975",
    "company_name": "SAANCHI GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079579": {
    "comapnyId": "7000079579",
    "company_name": "SWASTIK GOLDCORP PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016814": {
    "comapnyId": "7000016814",
    "company_name": "ZAR JEWELS PVT. LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010334": {
    "comapnyId": "7000010334",
    "company_name": "NICE GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012672": {
    "comapnyId": "7000012672",
    "company_name": "BAHETI GEMS & JEWELS PVT. LTD. ",
    "region": "region_5",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007797": {
    "comapnyId": "7000007797",
    "company_name": "ANMOL JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011570": {
    "comapnyId": "7000011570",
    "company_name": "B G PLATINUM",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009581": {
    "comapnyId": "7000009581",
    "company_name": "NEPTUNE GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075462": {
    "comapnyId": "7000075462",
    "company_name": "BHINDI JEWELLERS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050317": {
    "comapnyId": "7000050317",
    "company_name": "TANVI EXPORTS INDIA LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075847": {
    "comapnyId": "7000075847",
    "company_name": "SHREE PAGARIYA JEWELLERS PVT LTD",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066566": {
    "comapnyId": "7000066566",
    "company_name": "SRI GGN GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079841": {
    "comapnyId": "7000079841",
    "company_name": "TRIDENT JEWELS PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017059": {
    "comapnyId": "7000017059",
    "company_name": "RANIWALA JEWELLERS PVT. LTD. ",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080030": {
    "comapnyId": "7000080030",
    "company_name": "DIAMOND TREASURE",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003961": {
    "comapnyId": "7000003961",
    "company_name": "S.S.CHAINS JEWELLERY  PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000218": {
    "comapnyId": "7000000218",
    "company_name": "AWESOME SPARKLERS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059155": {
    "comapnyId": "7000059155",
    "company_name": "M G",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068583": {
    "comapnyId": "7000068583",
    "company_name": "KOSHA FINE JEWELS LIMITED",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012001": {
    "comapnyId": "7000012001",
    "company_name": "RAMESH CHAND JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078928": {
    "comapnyId": "7000078928",
    "company_name": "DIAMOND CREATIONS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 72,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007732": {
    "comapnyId": "7000007732",
    "company_name": "RAJ GEMS N JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008527": {
    "comapnyId": "7000008527",
    "company_name": "D P JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004176": {
    "comapnyId": "7000004176",
    "company_name": "HARDIK ZAVERI JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014272": {
    "comapnyId": "7000014272",
    "company_name": "BAANGANGA GOLD & DIAMOND (I) PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047491": {
    "comapnyId": "7000047491",
    "company_name": "S R GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015370": {
    "comapnyId": "7000015370",
    "company_name": "SHAKTI JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061174": {
    "comapnyId": "7000061174",
    "company_name": "V.K. JEWELLERS",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058916": {
    "comapnyId": "7000058916",
    "company_name": "R K BRACELETS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080164": {
    "comapnyId": "7000080164",
    "company_name": "SHEAURA JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011961": {
    "comapnyId": "7000011961",
    "company_name": "ACHAL JEWELS  PRIVATE LIMITED",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078328": {
    "comapnyId": "7000078328",
    "company_name": "ARADHANA JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005881": {
    "comapnyId": "7000005881",
    "company_name": "RAJSHREE GEMS AND JEWELS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026501": {
    "comapnyId": "7000026501",
    "company_name": "S R JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006456": {
    "comapnyId": "7000006456",
    "company_name": "KIRAN JEWELS INDIA",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059151": {
    "comapnyId": "7000059151",
    "company_name": "MITTAL PEARLS AND JEWELLERY",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015047": {
    "comapnyId": "7000015047",
    "company_name": "NEXARO JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009143": {
    "comapnyId": "7000009143",
    "company_name": "ARIHANT GEMS N JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070690": {
    "comapnyId": "7000070690",
    "company_name": "SUNRISE AURO & DIAMOND PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006778": {
    "comapnyId": "7000006778",
    "company_name": "CARAT COUTURE FINE JEWELLERY LLP",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015661": {
    "comapnyId": "7000015661",
    "company_name": "SILVER EMPORIUM PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037528": {
    "comapnyId": "7000037528",
    "company_name": "KANAK GEM & JEWELRY",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000077582": {
    "comapnyId": "7000077582",
    "company_name": "SAMBAV DIAMOND LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000463": {
    "comapnyId": "7000000463",
    "company_name": "MUNNII GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016383": {
    "comapnyId": "7000016383",
    "company_name": "V-CHAINS JEWELLERY PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000822": {
    "comapnyId": "7000000822",
    "company_name": "ANMOL DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079948": {
    "comapnyId": "7000079948",
    "company_name": "INDRAHEER GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000069804": {
    "comapnyId": "7000069804",
    "company_name": "SIAM JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010428": {
    "comapnyId": "7000010428",
    "company_name": "R. KOTHARI & CO. JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000272": {
    "comapnyId": "7000000272",
    "company_name": "A. MAHENDRA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016820": {
    "comapnyId": "7000016820",
    "company_name": "S.S. JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007382": {
    "comapnyId": "7000007382",
    "company_name": "L. GOPAL & SONS JEWELLERS ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058828": {
    "comapnyId": "7000058828",
    "company_name": "MEHTA JEWELS EMPORIUM",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000047313": {
    "comapnyId": "7000047313",
    "company_name": "JAYSHANKAR GEMS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000037": {
    "comapnyId": "7000000037",
    "company_name": "P&S GALVASOLS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057605": {
    "comapnyId": "7000057605",
    "company_name": "HEEDARIO GEMS AND JEWELS",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000071271": {
    "comapnyId": "7000071271",
    "company_name": "SHANKESHWAR JEWELCRAFT PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004026": {
    "comapnyId": "7000004026",
    "company_name": "GNS JEWELLERY",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002675": {
    "comapnyId": "7000002675",
    "company_name": "SILETTA GOLD  ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013190": {
    "comapnyId": "7000013190",
    "company_name": "PRIDE GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006333": {
    "comapnyId": "7000006333",
    "company_name": "ASHAPURI GOLD ORNAMENT LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080017": {
    "comapnyId": "7000080017",
    "company_name": "MALLINATH JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006889": {
    "comapnyId": "7000006889",
    "company_name": "NAHAR DIAMOND ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078465": {
    "comapnyId": "7000078465",
    "company_name": "MOON EXPORTS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003246": {
    "comapnyId": "7000003246",
    "company_name": "R.V.J.ENTERPRISES PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008052": {
    "comapnyId": "7000008052",
    "company_name": "SRI SIDDI VINAYAK JEWELLERS AND EXPORTS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066135": {
    "comapnyId": "7000066135",
    "company_name": "AADYA CREATIONS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068348": {
    "comapnyId": "7000068348",
    "company_name": "ANOOTHI JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004280": {
    "comapnyId": "7000004280",
    "company_name": "MAYFAIR CREATIONS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009674": {
    "comapnyId": "7000009674",
    "company_name": "NINE JEWELLERY ",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013051": {
    "comapnyId": "7000013051",
    "company_name": "YASONI GOLDIAM PVT LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011800": {
    "comapnyId": "7000011800",
    "company_name": "SHRI AKSHAR GOLD ORNAMENTS LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006931": {
    "comapnyId": "7000006931",
    "company_name": "PRISM INTERNATIONAL ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050756": {
    "comapnyId": "7000050756",
    "company_name": "SANGEETA BOOCHRA JAIPUR",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005252": {
    "comapnyId": "7000005252",
    "company_name": "TAPTI JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016833": {
    "comapnyId": "7000016833",
    "company_name": "AURA JEWELS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000390": {
    "comapnyId": "7000000390",
    "company_name": "D.P. DESIGNS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003988": {
    "comapnyId": "7000003988",
    "company_name": "MERU DIAMOND (I) PVT.LTD ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000459": {
    "comapnyId": "7000000459",
    "company_name": "MUSKAAN GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038025": {
    "comapnyId": "7000038025",
    "company_name": "SURESH JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061426": {
    "comapnyId": "7000061426",
    "company_name": "VIJAY JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079935": {
    "comapnyId": "7000079935",
    "company_name": "TEYANA JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000019018": {
    "comapnyId": "7000019018",
    "company_name": "SESMAL JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015529": {
    "comapnyId": "7000015529",
    "company_name": "SHREE KALPTARU JEWELS  (I) P.LT",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000321": {
    "comapnyId": "7000000321",
    "company_name": "PALSANI JEWELLERS PVT. LTD. ",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015605": {
    "comapnyId": "7000015605",
    "company_name": "SHUBH DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003390": {
    "comapnyId": "7000003390",
    "company_name": "INDIANIA JEWELLERY COMPANY   PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013638": {
    "comapnyId": "7000013638",
    "company_name": "DAGINA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005151": {
    "comapnyId": "7000005151",
    "company_name": "PUSHPAK JEWELLERS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012648": {
    "comapnyId": "7000012648",
    "company_name": "MILANA KREATIONS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000608": {
    "comapnyId": "7000000608",
    "company_name": "JEWEL HOUSE",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009553": {
    "comapnyId": "7000009553",
    "company_name": "VIKRAM MEHTA DESIGN STUDIO PVT LTD",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003212": {
    "comapnyId": "7000003212",
    "company_name": "PANI GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008109": {
    "comapnyId": "7000008109",
    "company_name": "RATI JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008377": {
    "comapnyId": "7000008377",
    "company_name": "MASTER CHAIN PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008326": {
    "comapnyId": "7000008326",
    "company_name": "MANUBHAI ZAVERI ORNAMENTS PVT. LTD.",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059247": {
    "comapnyId": "7000059247",
    "company_name": "KALASH GOLD AND ORNAMENTS PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012008": {
    "comapnyId": "7000012008",
    "company_name": "SHAKTI GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008298": {
    "comapnyId": "7000008298",
    "company_name": "HARSH CRETIONS INDIA ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015609": {
    "comapnyId": "7000015609",
    "company_name": "SHUBH JEWELLERY (AURA) PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003957": {
    "comapnyId": "7000003957",
    "company_name": "SWARN SHRISHTI JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000471": {
    "comapnyId": "7000000471",
    "company_name": "SHARDA JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061075": {
    "comapnyId": "7000061075",
    "company_name": "SHUBHPRATEEK JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051622": {
    "comapnyId": "7000051622",
    "company_name": "FIONAA GOLD PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000076054": {
    "comapnyId": "7000076054",
    "company_name": "VIJAY SHANTI ARTS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003596": {
    "comapnyId": "7000003596",
    "company_name": "VARAKRUPA JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000026": {
    "comapnyId": "7000000026",
    "company_name": "PUSHPA JEWELLERS  LIMITED",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044649": {
    "comapnyId": "7000044649",
    "company_name": "VARDHMAN JEWELS TECH PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008300": {
    "comapnyId": "7000008300",
    "company_name": "MANISH JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015616": {
    "comapnyId": "7000015616",
    "company_name": "SHWET RATAN IMPEX",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079661": {
    "comapnyId": "7000079661",
    "company_name": "GOLD STRINGS JEWELLERY PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009339": {
    "comapnyId": "7000009339",
    "company_name": "SADHANA GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001035": {
    "comapnyId": "7000001035",
    "company_name": "DHANRUPJI DEVAJI CO ",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017234": {
    "comapnyId": "7000017234",
    "company_name": "NELKT CREATION ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004323": {
    "comapnyId": "7000004323",
    "company_name": "DHANRESHA GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016915": {
    "comapnyId": "7000016915",
    "company_name": "ALANKAR INTERNATIONAL PVT. LTD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014117": {
    "comapnyId": "7000014117",
    "company_name": "SHRADDHA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038267": {
    "comapnyId": "7000038267",
    "company_name": "M. SASHI BADALIA & SONS PVT. LTD.",
    "region": "region_5",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000050137": {
    "comapnyId": "7000050137",
    "company_name": "VALENTINE JADAU",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011378": {
    "comapnyId": "7000011378",
    "company_name": "JKS JEWELS PVT LTD",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011815": {
    "comapnyId": "7000011815",
    "company_name": "S M GOLD ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014895": {
    "comapnyId": "7000014895",
    "company_name": "SAHELI JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012034": {
    "comapnyId": "7000012034",
    "company_name": "UNIQUE CHAINS AND JEWELS LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059791": {
    "comapnyId": "7000059791",
    "company_name": "RVJ JEWELLERS PRIVATE LIMITED",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003208": {
    "comapnyId": "7000003208",
    "company_name": "MINALAXMI EXIM ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016061": {
    "comapnyId": "7000016061",
    "company_name": "SURYA GOLDS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014604": {
    "comapnyId": "7000014604",
    "company_name": "BHINDI MANUFACTURERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011479": {
    "comapnyId": "7000011479",
    "company_name": "SHREE NAKODA CREATION ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079665": {
    "comapnyId": "7000079665",
    "company_name": "SOLANKI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052703": {
    "comapnyId": "7000052703",
    "company_name": "SHREE PARAM GEMS AND JEWELLERY LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060853": {
    "comapnyId": "7000060853",
    "company_name": "SAMRUDDHI JEWELCRAFT PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011089": {
    "comapnyId": "7000011089",
    "company_name": "ABDHI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003277": {
    "comapnyId": "7000003277",
    "company_name": "RAJ DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015626": {
    "comapnyId": "7000015626",
    "company_name": "SWARNSARITA JEWELS INDIA LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012917": {
    "comapnyId": "7000012917",
    "company_name": "RUSHABH DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047183": {
    "comapnyId": "7000047183",
    "company_name": "GOLDEN RAY CHAINS & JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007503": {
    "comapnyId": "7000007503",
    "company_name": "LAXMI JEWELLERY EXPORT   PVT. LTD.",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052565": {
    "comapnyId": "7000052565",
    "company_name": "NAVRITHI JEWELS PVT LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066646": {
    "comapnyId": "7000066646",
    "company_name": "SSVAR LLP",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037447": {
    "comapnyId": "7000037447",
    "company_name": "SHANTINATH PEARLS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008715": {
    "comapnyId": "7000008715",
    "company_name": "SITARA JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012459": {
    "comapnyId": "7000012459",
    "company_name": "ANMOL SWARN INDIA PVT  LTD.",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014916": {
    "comapnyId": "7000014916",
    "company_name": "SHREE BHOMIYA GEMS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069767": {
    "comapnyId": "7000069767",
    "company_name": "REGENT GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010872": {
    "comapnyId": "7000010872",
    "company_name": "PRECIOUS GEMS & JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059269": {
    "comapnyId": "7000059269",
    "company_name": "MI & MY JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004520": {
    "comapnyId": "7000004520",
    "company_name": "NAVPUSHPA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079235": {
    "comapnyId": "7000079235",
    "company_name": "JEWELS BY SOLANKI",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009037": {
    "comapnyId": "7000009037",
    "company_name": "GEMS (INDIA)",
    "region": "region_5",
    "section": "sectionData_3",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015763": {
    "comapnyId": "7000015763",
    "company_name": "SONI NANALAL BECHARDAS  JEWELLERS PVT. LTD.",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059348": {
    "comapnyId": "7000059348",
    "company_name": "ACLASS DIAMOND LLP",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078591": {
    "comapnyId": "7000078591",
    "company_name": "VEEDI JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053088": {
    "comapnyId": "7000053088",
    "company_name": "EKTA DIAMOND LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079017": {
    "comapnyId": "7000079017",
    "company_name": "SHAKUN JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009283": {
    "comapnyId": "7000009283",
    "company_name": "CLASSIC ORNAMENTS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070142": {
    "comapnyId": "7000070142",
    "company_name": "AVSAR GOLD",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006017": {
    "comapnyId": "7000006017",
    "company_name": "M S DIAAGEM ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013092": {
    "comapnyId": "7000013092",
    "company_name": "S. VINODKUMAR DIAMONDS PVT.LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061915": {
    "comapnyId": "7000061915",
    "company_name": "KRIM DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037999": {
    "comapnyId": "7000037999",
    "company_name": "OMKAR JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070012": {
    "comapnyId": "7000070012",
    "company_name": "VAIBHAV CREATIONS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070119": {
    "comapnyId": "7000070119",
    "company_name": "ZAMBAD INDUSTRIES PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057645": {
    "comapnyId": "7000057645",
    "company_name": "THASHNA JEWELLERY",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069990": {
    "comapnyId": "7000069990",
    "company_name": "ATUL JEWELLERS",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000040757": {
    "comapnyId": "7000040757",
    "company_name": "SHEETAL GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063515": {
    "comapnyId": "7000063515",
    "company_name": "AASHIRWAD JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004461": {
    "comapnyId": "7000004461",
    "company_name": "SONA RUPA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044490": {
    "comapnyId": "7000044490",
    "company_name": "T. GULABCHAND JAIN",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000072618": {
    "comapnyId": "7000072618",
    "company_name": "UNIVERSAL JEWELS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000051206": {
    "comapnyId": "7000051206",
    "company_name": "RADHE KRISHNA GEMS & JEWELLERY",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014832": {
    "comapnyId": "7000014832",
    "company_name": "MEHTA GOLD PVT. LTD. ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079765": {
    "comapnyId": "7000079765",
    "company_name": "SUVARRNA JEWELS",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009097": {
    "comapnyId": "7000009097",
    "company_name": "GOLD MINE ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015155": {
    "comapnyId": "7000015155",
    "company_name": "BAANGANGA DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009121": {
    "comapnyId": "7000009121",
    "company_name": "MAHASHILA JEWELLERY PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000019011": {
    "comapnyId": "7000019011",
    "company_name": "N K JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069882": {
    "comapnyId": "7000069882",
    "company_name": "A GEMAWAT & SONS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080125": {
    "comapnyId": "7000080125",
    "company_name": "REAL MANGALSUTRA",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070305": {
    "comapnyId": "7000070305",
    "company_name": "ROYAL ANGEL PEARL GEM JEWELS LLP",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000062025": {
    "comapnyId": "7000062025",
    "company_name": "EMERGEDIAM LLP",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000035584": {
    "comapnyId": "7000035584",
    "company_name": "KAPOOR CHAINS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026269": {
    "comapnyId": "7000026269",
    "company_name": "VK JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066440": {
    "comapnyId": "7000066440",
    "company_name": "MANOKAMANA JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008800": {
    "comapnyId": "7000008800",
    "company_name": "ORO PRECIOUS METALS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009847": {
    "comapnyId": "7000009847",
    "company_name": "DIAJE ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017334": {
    "comapnyId": "7000017334",
    "company_name": "NICE DIAMONDS (INDIA) PVT. LTD ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002059": {
    "comapnyId": "7000002059",
    "company_name": "HEMRATNA JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061576": {
    "comapnyId": "7000061576",
    "company_name": "MD GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050586": {
    "comapnyId": "7000050586",
    "company_name": "LEELA GOLD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012136": {
    "comapnyId": "7000012136",
    "company_name": "JINKUSHAL JEWELLERS ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001940": {
    "comapnyId": "7000001940",
    "company_name": "AADEY JEWELS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002357": {
    "comapnyId": "7000002357",
    "company_name": "LURBA JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069965": {
    "comapnyId": "7000069965",
    "company_name": "NAMOHARIHANT CZ JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000382": {
    "comapnyId": "7000000382",
    "company_name": "D.N. JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007332": {
    "comapnyId": "7000007332",
    "company_name": "AKASH GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000434": {
    "comapnyId": "7000000434",
    "company_name": "DASSANI BROTHERS",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061084": {
    "comapnyId": "7000061084",
    "company_name": "SHREE JI JEWELLERY MANUFACTURERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006751": {
    "comapnyId": "7000006751",
    "company_name": "SOMIRA DIAM ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002104": {
    "comapnyId": "7000002104",
    "company_name": "TIRTH GOLD ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009801": {
    "comapnyId": "7000009801",
    "company_name": "ANJA JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069607": {
    "comapnyId": "7000069607",
    "company_name": "LEO SILVER ART PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051497": {
    "comapnyId": "7000051497",
    "company_name": "MODERN JEWELS PVT LTD",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066079": {
    "comapnyId": "7000066079",
    "company_name": "JEWEL PARK",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000791": {
    "comapnyId": "7000000791",
    "company_name": "MANJALLY JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000002274": {
    "comapnyId": "7000002274",
    "company_name": "LAXMI GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009334": {
    "comapnyId": "7000009334",
    "company_name": "J.P.GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052667": {
    "comapnyId": "7000052667",
    "company_name": "SWARN DEEP",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016779": {
    "comapnyId": "7000016779",
    "company_name": "HREENKAR JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013212": {
    "comapnyId": "7000013212",
    "company_name": "SK JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050810": {
    "comapnyId": "7000050810",
    "company_name": "HASMUKH PAREKH JEWELLERS",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061098": {
    "comapnyId": "7000061098",
    "company_name": "SHREE AMBIKA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009745": {
    "comapnyId": "7000009745",
    "company_name": "BAID TRADING CORPORATION ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007436": {
    "comapnyId": "7000007436",
    "company_name": "LADIWALA ENTERPRISES",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017608": {
    "comapnyId": "7000017608",
    "company_name": "ANMOL JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006960": {
    "comapnyId": "7000006960",
    "company_name": "RII SIGNATURE JOOLRY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000037981": {
    "comapnyId": "7000037981",
    "company_name": "LABDHI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057543": {
    "comapnyId": "7000057543",
    "company_name": "DANTARA DIAMONDS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069948": {
    "comapnyId": "7000069948",
    "company_name": "NEW BOMBAY JEWELLERS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079614": {
    "comapnyId": "7000079614",
    "company_name": "SHREE RAJ RAJENDRA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006466": {
    "comapnyId": "7000006466",
    "company_name": "RIVERSTONE JEWELS LLP ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003323": {
    "comapnyId": "7000003323",
    "company_name": "CHOKSHI VACHHARAJ MAKANJI & COMPANY",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014924": {
    "comapnyId": "7000014924",
    "company_name": "RAMESHCHAND & SONS J EWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002189": {
    "comapnyId": "7000002189",
    "company_name": "SHREE KRUPA GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000526": {
    "comapnyId": "7000000526",
    "company_name": "DEREWALA  INDUSTRIES LTD.",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079823": {
    "comapnyId": "7000079823",
    "company_name": "AUM SWARNMANDIR JEWEL CREATION",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009599": {
    "comapnyId": "7000009599",
    "company_name": "SAMTA JEWELS LLP ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017249": {
    "comapnyId": "7000017249",
    "company_name": "MANAK JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016864": {
    "comapnyId": "7000016864",
    "company_name": "KAMAL NARNOLI JEWELLERS ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005790": {
    "comapnyId": "7000005790",
    "company_name": "S.R ORNAMENTS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044091": {
    "comapnyId": "7000044091",
    "company_name": "RITESH GOLD LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079653": {
    "comapnyId": "7000079653",
    "company_name": "SHREE TULJA BHAVANI JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010135": {
    "comapnyId": "7000010135",
    "company_name": "AADISH GOLD LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026262": {
    "comapnyId": "7000026262",
    "company_name": "SHINE GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009377": {
    "comapnyId": "7000009377",
    "company_name": "B.D. BANGLES",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014949": {
    "comapnyId": "7000014949",
    "company_name": "SUKHRAJ JEWELS PVT. LTD. ",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037986": {
    "comapnyId": "7000037986",
    "company_name": "MAYUR GOLD PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000052651": {
    "comapnyId": "7000052651",
    "company_name": "SHIVENDRA JEWELLERS PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017232": {
    "comapnyId": "7000017232",
    "company_name": "R.B. JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061010": {
    "comapnyId": "7000061010",
    "company_name": "HOUSE OF SPARSH PVT LTD",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011577": {
    "comapnyId": "7000011577",
    "company_name": "THATHI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060964": {
    "comapnyId": "7000060964",
    "company_name": "YASHODA JAGDISH & SONS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017664": {
    "comapnyId": "7000017664",
    "company_name": "ARIHA DIAMOND JEWELLERY P. LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014812": {
    "comapnyId": "7000014812",
    "company_name": "LOTUS JEWELLERY CREATION ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066336": {
    "comapnyId": "7000066336",
    "company_name": "SILVER EMPORIUM ARTE LLP.",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008232": {
    "comapnyId": "7000008232",
    "company_name": "SHILPAM JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051439": {
    "comapnyId": "7000051439",
    "company_name": "AARYA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051748": {
    "comapnyId": "7000051748",
    "company_name": "JEWELS OF RAJPUTAANA",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053094": {
    "comapnyId": "7000053094",
    "company_name": "PR JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079763": {
    "comapnyId": "7000079763",
    "company_name": "SWASTHIK GEMS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037693": {
    "comapnyId": "7000037693",
    "company_name": "STAR DIAMONDS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057602": {
    "comapnyId": "7000057602",
    "company_name": "RAJENDRA JEWELLERNX PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002306": {
    "comapnyId": "7000002306",
    "company_name": "VEE J JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038447": {
    "comapnyId": "7000038447",
    "company_name": "PRAVIN ORNAMENTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015823": {
    "comapnyId": "7000015823",
    "company_name": "SRI VIJAY DURGA MAHASHAKTI JEWELLERS & EXPORTERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006378": {
    "comapnyId": "7000006378",
    "company_name": "EON JEWELLERY PVT LTD",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008839": {
    "comapnyId": "7000008839",
    "company_name": "E- DESIGNS ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075344": {
    "comapnyId": "7000075344",
    "company_name": "UNI DIAM JEWELLERY LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051563": {
    "comapnyId": "7000051563",
    "company_name": "VAJRA",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011792": {
    "comapnyId": "7000011792",
    "company_name": "LAKHTARWALA JEWELLERS PVT LTD ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058871": {
    "comapnyId": "7000058871",
    "company_name": "ROYAL 925 STERLING SILVER JEWELLERY",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000812": {
    "comapnyId": "7000000812",
    "company_name": "DIA JEWEL ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000540": {
    "comapnyId": "7000000540",
    "company_name": "SWAROOP JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012682": {
    "comapnyId": "7000012682",
    "company_name": "TULSI DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044723": {
    "comapnyId": "7000044723",
    "company_name": "AMARKOSH JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060785": {
    "comapnyId": "7000060785",
    "company_name": "NANESH DIAMONDS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051697": {
    "comapnyId": "7000051697",
    "company_name": "GOVINDJI GLOBAL PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011519": {
    "comapnyId": "7000011519",
    "company_name": "R.P. ORNAMENTS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047292": {
    "comapnyId": "7000047292",
    "company_name": "MAGNIC TECHNOLOGIES PVT LTD",
    "region": "region_1",
    "section": "sectionData_12",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000009967": {
    "comapnyId": "7000009967",
    "company_name": "ORIENTAL GEMCO PVT. LTD. ",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015966": {
    "comapnyId": "7000015966",
    "company_name": "SUNDARAM CHAINS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009276": {
    "comapnyId": "7000009276",
    "company_name": "SHRINGAR HOUSE OF MANGALSUTRA LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002205": {
    "comapnyId": "7000002205",
    "company_name": "VIPS JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049772": {
    "comapnyId": "7000049772",
    "company_name": "NEETI JEWELLS LLP",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003350": {
    "comapnyId": "7000003350",
    "company_name": "RAKSHIKA JEWELS LLP ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008285": {
    "comapnyId": "7000008285",
    "company_name": "ANNORAA CREATIONS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006803": {
    "comapnyId": "7000006803",
    "company_name": "LAXMI JEWELLERY CHENNAI   PVT LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008858": {
    "comapnyId": "7000008858",
    "company_name": "MITHALI GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000048346": {
    "comapnyId": "7000048346",
    "company_name": "MANIRATNA CHAINS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003352": {
    "comapnyId": "7000003352",
    "company_name": "J.S JEWEL OM LLP ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006294": {
    "comapnyId": "7000006294",
    "company_name": "P HIRANI EXPORTS LLP",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066461": {
    "comapnyId": "7000066461",
    "company_name": "S. B. GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013809": {
    "comapnyId": "7000013809",
    "company_name": "SEJAL JEWELLERY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000035489": {
    "comapnyId": "7000035489",
    "company_name": "DANTARA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075863": {
    "comapnyId": "7000075863",
    "company_name": "VANIOR JEWELS PVT LTD",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002473": {
    "comapnyId": "7000002473",
    "company_name": "GEM CRAFTS ENTERPRISES PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079648": {
    "comapnyId": "7000079648",
    "company_name": "BLAZE DIAMONDS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015505": {
    "comapnyId": "7000015505",
    "company_name": "SHREE DIAMOND ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004740": {
    "comapnyId": "7000004740",
    "company_name": "BHAVIKA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052685": {
    "comapnyId": "7000052685",
    "company_name": "S K JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001888": {
    "comapnyId": "7000001888",
    "company_name": "MAA GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003007": {
    "comapnyId": "7000003007",
    "company_name": "GUNJAN JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 72,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012397": {
    "comapnyId": "7000012397",
    "company_name": "BANSI JEWELLERS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009672": {
    "comapnyId": "7000009672",
    "company_name": "DHRISHA JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015249": {
    "comapnyId": "7000015249",
    "company_name": "SHREE FINE JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001819": {
    "comapnyId": "7000001819",
    "company_name": "GDK JEWELS PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016983": {
    "comapnyId": "7000016983",
    "company_name": "PAHINI JEWELLERY PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010185": {
    "comapnyId": "7000010185",
    "company_name": "SKY GOLD AND DIAMONDS LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 108,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003321": {
    "comapnyId": "7000003321",
    "company_name": "M.R.GOLD PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016075": {
    "comapnyId": "7000016075",
    "company_name": "SWARNA MANGAL JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011702": {
    "comapnyId": "7000011702",
    "company_name": "RAINBOW",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000070306": {
    "comapnyId": "7000070306",
    "company_name": "CULTURE ANTIQUE JEWELLERY PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000011460": {
    "comapnyId": "7000011460",
    "company_name": "RUDRA JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009491": {
    "comapnyId": "7000009491",
    "company_name": "RISHAB JEWELS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053082": {
    "comapnyId": "7000053082",
    "company_name": "SHAKTI ENTERPRISE",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000000743": {
    "comapnyId": "7000000743",
    "company_name": "DHARMESH JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052552": {
    "comapnyId": "7000052552",
    "company_name": "KAASHVI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008346": {
    "comapnyId": "7000008346",
    "company_name": "THIRUMALA  ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016617": {
    "comapnyId": "7000016617",
    "company_name": "VIRAASAT JEWELS PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013267": {
    "comapnyId": "7000013267",
    "company_name": "SHREE OMKAR JEWELLER S (P) LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000034760": {
    "comapnyId": "7000034760",
    "company_name": "SAHANARATNABH PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011746": {
    "comapnyId": "7000011746",
    "company_name": "ZAVERAT ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014770": {
    "comapnyId": "7000014770",
    "company_name": "CHAINS CORNER JEWELLERY (I) PV T.LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010591": {
    "comapnyId": "7000010591",
    "company_name": "POOJA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011661": {
    "comapnyId": "7000011661",
    "company_name": "RADHEY SHYAM JEWELLERS PRIVATE LIMITED",
    "region": "region_6",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080065": {
    "comapnyId": "7000080065",
    "company_name": "ASTMANGAL ORNAMENTS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057568": {
    "comapnyId": "7000057568",
    "company_name": "NAKSHATRA CREATION",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000035942": {
    "comapnyId": "7000035942",
    "company_name": "TG JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011035": {
    "comapnyId": "7000011035",
    "company_name": "PRISM ENTERPRISES PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012377": {
    "comapnyId": "7000012377",
    "company_name": "UNITOUCH CREATIONS LLP ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037961": {
    "comapnyId": "7000037961",
    "company_name": "MARS DIA JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047382": {
    "comapnyId": "7000047382",
    "company_name": "SHUBH CREATION",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014408": {
    "comapnyId": "7000014408",
    "company_name": "BEAUTY GEMS & JEWELLERY ",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063696": {
    "comapnyId": "7000063696",
    "company_name": "S P GOLD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049909": {
    "comapnyId": "7000049909",
    "company_name": "DHANAKSH JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075730": {
    "comapnyId": "7000075730",
    "company_name": "RATAN JEWELLERS & SONS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016961": {
    "comapnyId": "7000016961",
    "company_name": "CHAIN N CHAINS JEWELS LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044128": {
    "comapnyId": "7000044128",
    "company_name": "M. M. CORPORATION",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017243": {
    "comapnyId": "7000017243",
    "company_name": "STAR JEWELLERY ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026627": {
    "comapnyId": "7000026627",
    "company_name": "R S GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001942": {
    "comapnyId": "7000001942",
    "company_name": "DAZZLE DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000935": {
    "comapnyId": "7000000935",
    "company_name": "ROSE JEWELLERS  ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066647": {
    "comapnyId": "7000066647",
    "company_name": "NAMOSHREE GOLD LLP",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011769": {
    "comapnyId": "7000011769",
    "company_name": "RAJ JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057606": {
    "comapnyId": "7000057606",
    "company_name": "SERAKI GOLD LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053530": {
    "comapnyId": "7000053530",
    "company_name": "CREATIVE GOLD LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007195": {
    "comapnyId": "7000007195",
    "company_name": "P.R. JEWELLERS  ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000494": {
    "comapnyId": "7000000494",
    "company_name": "DEEPAK JEWELLERS ",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069750": {
    "comapnyId": "7000069750",
    "company_name": "APARAJITAA JEWEL",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000025490": {
    "comapnyId": "7000025490",
    "company_name": "INDERLAL BALMUKAND ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010575": {
    "comapnyId": "7000010575",
    "company_name": "TAHILRAM TIRTHDAS JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008275": {
    "comapnyId": "7000008275",
    "company_name": "MOMAI JEWELLERS LLP ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001109": {
    "comapnyId": "7000001109",
    "company_name": "R. V. ORNAMENTS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060707": {
    "comapnyId": "7000060707",
    "company_name": "SUTRAM JEWELS PVT LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000080072": {
    "comapnyId": "7000080072",
    "company_name": "K.K.SILVER",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011835": {
    "comapnyId": "7000011835",
    "company_name": "AADITYA DIAMGOLD PVT.LTD. ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002002": {
    "comapnyId": "7000002002",
    "company_name": "AMBICA CAST ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015394": {
    "comapnyId": "7000015394",
    "company_name": "SHANTI GOLD INTERNATIONAL LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066539": {
    "comapnyId": "7000066539",
    "company_name": "DEEPA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044497": {
    "comapnyId": "7000044497",
    "company_name": "RAJ GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011733": {
    "comapnyId": "7000011733",
    "company_name": "RAINBOW STONES ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004586": {
    "comapnyId": "7000004586",
    "company_name": "SPARKLING GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014820": {
    "comapnyId": "7000014820",
    "company_name": "SKY CHAINS & JEWELLERY PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012678": {
    "comapnyId": "7000012678",
    "company_name": "ROOPSHREE JEWELLERS PRIVATE  LIMITED",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010064": {
    "comapnyId": "7000010064",
    "company_name": "MANMOHAN EXPORTS",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007949": {
    "comapnyId": "7000007949",
    "company_name": "PARAS JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000046160": {
    "comapnyId": "7000046160",
    "company_name": "RAJLAXMI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060998": {
    "comapnyId": "7000060998",
    "company_name": "ANAND SHAH JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000054221": {
    "comapnyId": "7000054221",
    "company_name": "KANGANAM",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075984": {
    "comapnyId": "7000075984",
    "company_name": "ZEMERRA JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052597": {
    "comapnyId": "7000052597",
    "company_name": "SUNIL GEMS AND JEWELLERY PVT. LTD",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050618": {
    "comapnyId": "7000050618",
    "company_name": "MY CHAINS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061245": {
    "comapnyId": "7000061245",
    "company_name": "ADA JEWELS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052984": {
    "comapnyId": "7000052984",
    "company_name": "V. J. JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061302": {
    "comapnyId": "7000061302",
    "company_name": "KLASSIC MOUNTS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006281": {
    "comapnyId": "7000006281",
    "company_name": "KESHAVLAL DALPATBHAI ZAVERI & CO",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012759": {
    "comapnyId": "7000012759",
    "company_name": "ROYAL CHAINS PVT.LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013304": {
    "comapnyId": "7000013304",
    "company_name": "PADMAVATI CHAINS AND JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079873": {
    "comapnyId": "7000079873",
    "company_name": "REONA JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012117": {
    "comapnyId": "7000012117",
    "company_name": "PALAK JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037922": {
    "comapnyId": "7000037922",
    "company_name": "SHILPI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012321": {
    "comapnyId": "7000012321",
    "company_name": "VINAYAK JEWELLERS ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001910": {
    "comapnyId": "7000001910",
    "company_name": "RITIKA CHAINS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000023213": {
    "comapnyId": "7000023213",
    "company_name": "R D KAREL JEWELLERS PVT LTD ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003581": {
    "comapnyId": "7000003581",
    "company_name": "HEENA GEMS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047484": {
    "comapnyId": "7000047484",
    "company_name": "MAA SATTI JEWELS",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006372": {
    "comapnyId": "7000006372",
    "company_name": "MAMRAJ MUSSADILAL JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061046": {
    "comapnyId": "7000061046",
    "company_name": "DHEE SIGNATURE JEWELLERY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009638": {
    "comapnyId": "7000009638",
    "company_name": "AAKAR JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061008": {
    "comapnyId": "7000061008",
    "company_name": "PP ABHAY JEWELLERS PVT LTD",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070581": {
    "comapnyId": "7000070581",
    "company_name": "SURESH GARG GEMS LLP",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007668": {
    "comapnyId": "7000007668",
    "company_name": "LUCKY JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000026533": {
    "comapnyId": "7000026533",
    "company_name": "BHAGWATI JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010456": {
    "comapnyId": "7000010456",
    "company_name": "SRI MARUTI JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052664": {
    "comapnyId": "7000052664",
    "company_name": "RASHMINBHAI SHANTILAL ZINZUWADIA PVT LTD",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068064": {
    "comapnyId": "7000068064",
    "company_name": "SILVER SOURCE",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004266": {
    "comapnyId": "7000004266",
    "company_name": "ALLWIN JEWELLERS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014628": {
    "comapnyId": "7000014628",
    "company_name": "BIJOUX ARGENT PVT LTD ",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011024": {
    "comapnyId": "7000011024",
    "company_name": "PRIORITY JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016314": {
    "comapnyId": "7000016314",
    "company_name": "JASANI INDIA PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070366": {
    "comapnyId": "7000070366",
    "company_name": "1UNIQUE JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011822": {
    "comapnyId": "7000011822",
    "company_name": "DIVAS JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058887": {
    "comapnyId": "7000058887",
    "company_name": "RUSHABH JEWELS",
    "region": "region_2",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000890": {
    "comapnyId": "7000000890",
    "company_name": "OM GANESH JEWELLERS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075402": {
    "comapnyId": "7000075402",
    "company_name": "OMKALASH JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000015564": {
    "comapnyId": "7000015564",
    "company_name": "SHREEJEE JEWELLERS PVT.LTD. ",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006851": {
    "comapnyId": "7000006851",
    "company_name": "JHALAK JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075973": {
    "comapnyId": "7000075973",
    "company_name": "MAA BRIJESHWARI JEWELLERS",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069503": {
    "comapnyId": "7000069503",
    "company_name": "RADIANT JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061016": {
    "comapnyId": "7000061016",
    "company_name": "RADHA GEMS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011843": {
    "comapnyId": "7000011843",
    "company_name": "ZEVAR THE JEWELLERY WORLD ",
    "region": "region_4",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060837": {
    "comapnyId": "7000060837",
    "company_name": "SHREE I JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001978": {
    "comapnyId": "7000001978",
    "company_name": "MIDAS DIAMONDS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053547": {
    "comapnyId": "7000053547",
    "company_name": "NIRVAAN JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061029": {
    "comapnyId": "7000061029",
    "company_name": "JOHRISONS JEWELLERS PVT LTD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014042": {
    "comapnyId": "7000014042",
    "company_name": "M S KUNDAN CREATION ",
    "region": "region_6",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004982": {
    "comapnyId": "7000004982",
    "company_name": "SHUBH ART JEWELLERS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079915": {
    "comapnyId": "7000079915",
    "company_name": "RAMKUDI DESIGNER JOOLRY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000000563": {
    "comapnyId": "7000000563",
    "company_name": "CHAIN EXPERTS AND JE WELLERS PVT.LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003110": {
    "comapnyId": "7000003110",
    "company_name": "PRAGYA JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057182": {
    "comapnyId": "7000057182",
    "company_name": "P. K. JEWELLERS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000000694": {
    "comapnyId": "7000000694",
    "company_name": "DHANDIA GEMS CORPORATION ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052443": {
    "comapnyId": "7000052443",
    "company_name": "NAKODA GOLD JVM LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009048": {
    "comapnyId": "7000009048",
    "company_name": "LOVE GOLD ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016326": {
    "comapnyId": "7000016326",
    "company_name": "UNIQUE ART DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052329": {
    "comapnyId": "7000052329",
    "company_name": "SANKALP JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012628": {
    "comapnyId": "7000012628",
    "company_name": "NEO DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004035": {
    "comapnyId": "7000004035",
    "company_name": "UNIQUE VALLEY",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016265": {
    "comapnyId": "7000016265",
    "company_name": "TRUE CASTE JEWELLERY ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006264": {
    "comapnyId": "7000006264",
    "company_name": "SOLITAA DIAMONDS ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006463": {
    "comapnyId": "7000006463",
    "company_name": "JEWEL DARSHAN ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000045028": {
    "comapnyId": "7000045028",
    "company_name": "SANJAY KUMAR BAVISHI AND SON",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007269": {
    "comapnyId": "7000007269",
    "company_name": "KISHORE MOTIWALA ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063261": {
    "comapnyId": "7000063261",
    "company_name": "GANESH GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053117": {
    "comapnyId": "7000053117",
    "company_name": "MANGALDEEP CHAINS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079805": {
    "comapnyId": "7000079805",
    "company_name": "JARNAS JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049868": {
    "comapnyId": "7000049868",
    "company_name": "N.K. IMPEX",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047755": {
    "comapnyId": "7000047755",
    "company_name": "AQUA JEWELLERS",
    "region": "region_2",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075707": {
    "comapnyId": "7000075707",
    "company_name": "RAJGURU JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001609": {
    "comapnyId": "7000001609",
    "company_name": "FANCY DIAMONDS INDIA PRIVATE L IMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068333": {
    "comapnyId": "7000068333",
    "company_name": "NATHI LAL ASHOK KUMAR ",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052939": {
    "comapnyId": "7000052939",
    "company_name": "OSTWAL JEWELS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050856": {
    "comapnyId": "7000050856",
    "company_name": "SWARN VILLA",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015061": {
    "comapnyId": "7000015061",
    "company_name": "SIROYA CHAMPALAL UTTAMCHAND ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061125": {
    "comapnyId": "7000061125",
    "company_name": "TRADEMARK JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070347": {
    "comapnyId": "7000070347",
    "company_name": "M S GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009549": {
    "comapnyId": "7000009549",
    "company_name": "RAJ JEWELLERS ",
    "region": "region_4",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004954": {
    "comapnyId": "7000004954",
    "company_name": "CHINTAMANI GOLD ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002020": {
    "comapnyId": "7000002020",
    "company_name": "ABANS JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000017201": {
    "comapnyId": "7000017201",
    "company_name": "SHANKESH JEWELLERS LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004648": {
    "comapnyId": "7000004648",
    "company_name": "VARA JEWELS ",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013538": {
    "comapnyId": "7000013538",
    "company_name": "PAYAL GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001101": {
    "comapnyId": "7000001101",
    "company_name": "SAP JEWELS LLP ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000034402": {
    "comapnyId": "7000034402",
    "company_name": "DHYAAN JEWELS LLP.",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009220": {
    "comapnyId": "7000009220",
    "company_name": "PUNGALIA TRADING CORPORATION ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061093": {
    "comapnyId": "7000061093",
    "company_name": "PODDAR JEWELLERS",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000054288": {
    "comapnyId": "7000054288",
    "company_name": "SHREE GURU GOLD PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008266": {
    "comapnyId": "7000008266",
    "company_name": "ASTMANGAL CHAINS PVT LTD ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016986": {
    "comapnyId": "7000016986",
    "company_name": "SWASTIK JEWELS ",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007065": {
    "comapnyId": "7000007065",
    "company_name": "VERO STELLA JEWELS LLP ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013498": {
    "comapnyId": "7000013498",
    "company_name": "CHUNOBA GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007696": {
    "comapnyId": "7000007696",
    "company_name": "PM JEWELEX PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016711": {
    "comapnyId": "7000016711",
    "company_name": "WORLDWIDE GEM EXPORTS ",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016993": {
    "comapnyId": "7000016993",
    "company_name": "NAICE JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000067566": {
    "comapnyId": "7000067566",
    "company_name": "FOREVER JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000043208": {
    "comapnyId": "7000043208",
    "company_name": "S. G. KAREL & SONS JEWELLERS PVT. LTD. ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000050544": {
    "comapnyId": "7000050544",
    "company_name": "KANTHILAL AND SONS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007738": {
    "comapnyId": "7000007738",
    "company_name": "JENISHA JEWELS ARTS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005147": {
    "comapnyId": "7000005147",
    "company_name": "SHA RATANCHAND DILIPKUMAR OSWAL",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000005712": {
    "comapnyId": "7000005712",
    "company_name": "KANAKRATNA EXIM PVT.LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052513": {
    "comapnyId": "7000052513",
    "company_name": "CIYAZA INDUSTRIES LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000037655": {
    "comapnyId": "7000037655",
    "company_name": "SIDDHESHWAR GEMS & JEWELS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069633": {
    "comapnyId": "7000069633",
    "company_name": "RAYAN DESIGNS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000073730": {
    "comapnyId": "7000073730",
    "company_name": "M K GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069973": {
    "comapnyId": "7000069973",
    "company_name": "R K SONI AND SONS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001917": {
    "comapnyId": "7000001917",
    "company_name": "V U CHAINS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000014981": {
    "comapnyId": "7000014981",
    "company_name": "PARTH ORNAMENTS PVT. LTD. ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005744": {
    "comapnyId": "7000005744",
    "company_name": "MANGALSUTRAM ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000067023": {
    "comapnyId": "7000067023",
    "company_name": "VARNICA JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010602": {
    "comapnyId": "7000010602",
    "company_name": "VALDARIA IMPEX PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070117": {
    "comapnyId": "7000070117",
    "company_name": "RIDDHI SIDDHI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004421": {
    "comapnyId": "7000004421",
    "company_name": "J.P. EXPORTS ",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003386": {
    "comapnyId": "7000003386",
    "company_name": "DEEPA JEWELLERS PRIVATE  LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075394": {
    "comapnyId": "7000075394",
    "company_name": "AMOGH JEWELS PVT LTD",
    "region": "region_1",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000076586": {
    "comapnyId": "7000076586",
    "company_name": "SUVIDHI ORNA PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052715": {
    "comapnyId": "7000052715",
    "company_name": "RUSHABH JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015786": {
    "comapnyId": "7000015786",
    "company_name": "SPARKLE DIAM PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070364": {
    "comapnyId": "7000070364",
    "company_name": "DIAGLITER LLP",
    "region": "region_2",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006399": {
    "comapnyId": "7000006399",
    "company_name": "KHUSHALI JEWELS (P) LIMITED ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069611": {
    "comapnyId": "7000069611",
    "company_name": "S V JEWELLERS",
    "region": "region_1",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070256": {
    "comapnyId": "7000070256",
    "company_name": "SAMARTH JEWELLERY CREATIONS PVT LTD",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000076966": {
    "comapnyId": "7000076966",
    "company_name": "QUBE STAR LLP",
    "region": "region_3",
    "section": "sectionData_6",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005320": {
    "comapnyId": "7000005320",
    "company_name": "VAGONI TRADE LINK ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000013722": {
    "comapnyId": "7000013722",
    "company_name": "SUNIL GOLD INDIA LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000047350": {
    "comapnyId": "7000047350",
    "company_name": "M.R.PARMAR",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016071": {
    "comapnyId": "7000016071",
    "company_name": "SWARNSHILP CHAINS & JEWELLERS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 54,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075902": {
    "comapnyId": "7000075902",
    "company_name": "PLUTUS JEWELS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079608": {
    "comapnyId": "7000079608",
    "company_name": "SHREE JI IMPEX",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069595": {
    "comapnyId": "7000069595",
    "company_name": "SHRIMAL GEMS",
    "region": "region_4",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069814": {
    "comapnyId": "7000069814",
    "company_name": "BHIKSHU JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000076650": {
    "comapnyId": "7000076650",
    "company_name": "KLIORO FINE JEWELLERY PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002635": {
    "comapnyId": "7000002635",
    "company_name": "SETS JEWELLERY PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000062247": {
    "comapnyId": "7000062247",
    "company_name": "MINAL PALACE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000039221": {
    "comapnyId": "7000039221",
    "company_name": "NITMAN GOLD EXPORTS LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057542": {
    "comapnyId": "7000057542",
    "company_name": "KK ORNAMENTS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070985": {
    "comapnyId": "7000070985",
    "company_name": "MAHAVIR JEWELLERS NX LLP",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038537": {
    "comapnyId": "7000038537",
    "company_name": "SHILP CHAINS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058981": {
    "comapnyId": "7000058981",
    "company_name": "KIA DIAMONDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000079794": {
    "comapnyId": "7000079794",
    "company_name": "D. T. JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000067646": {
    "comapnyId": "7000067646",
    "company_name": "MITRA ORNAMENTS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008087": {
    "comapnyId": "7000008087",
    "company_name": "MAHEK GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000016244": {
    "comapnyId": "7000016244",
    "company_name": "TRADITIONS ",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053134": {
    "comapnyId": "7000053134",
    "company_name": "JEWEL N DESIGN",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008459": {
    "comapnyId": "7000008459",
    "company_name": "DEVANSH CREATION PRIVATE LIMITED",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000057275": {
    "comapnyId": "7000057275",
    "company_name": "TJ JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078372": {
    "comapnyId": "7000078372",
    "company_name": "R B ORNAMENT",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011269": {
    "comapnyId": "7000011269",
    "company_name": "MANGALMANI JEWELLERS LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000005341": {
    "comapnyId": "7000005341",
    "company_name": "JEWELSMITH ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066428": {
    "comapnyId": "7000066428",
    "company_name": "SHINE JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000008913": {
    "comapnyId": "7000008913",
    "company_name": "DEVI JEWELLERS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010059": {
    "comapnyId": "7000010059",
    "company_name": "P. MANGATRAM JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069849": {
    "comapnyId": "7000069849",
    "company_name": "SHREE JOYERIA",
    "region": "region_3",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001514": {
    "comapnyId": "7000001514",
    "company_name": "EARTH STONE INC ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000059467": {
    "comapnyId": "7000059467",
    "company_name": "PARV GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000061137": {
    "comapnyId": "7000061137",
    "company_name": "SACHHIYAY GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003476": {
    "comapnyId": "7000003476",
    "company_name": "HARE RAMA HARE KRISHNA CORALS  PVT. LTD.",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078653": {
    "comapnyId": "7000078653",
    "company_name": "KETAN GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044223": {
    "comapnyId": "7000044223",
    "company_name": "S. M. GOLD LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053365": {
    "comapnyId": "7000053365",
    "company_name": "HUNAR GOLD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070558": {
    "comapnyId": "7000070558",
    "company_name": "PEARL GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000061521": {
    "comapnyId": "7000061521",
    "company_name": "SUN GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000010488": {
    "comapnyId": "7000010488",
    "company_name": "KESHAVLAL F GANDHI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006598": {
    "comapnyId": "7000006598",
    "company_name": "KRIPA JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015147": {
    "comapnyId": "7000015147",
    "company_name": "SRI RAJ JEWELLERY ",
    "region": "region_1",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012437": {
    "comapnyId": "7000012437",
    "company_name": "OM ALANKAR JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003801": {
    "comapnyId": "7000003801",
    "company_name": "ANOKHI JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000006382": {
    "comapnyId": "7000006382",
    "company_name": "DHARMA JEWELS",
    "region": "region_3",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000062071": {
    "comapnyId": "7000062071",
    "company_name": "DIVIJA JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002807": {
    "comapnyId": "7000002807",
    "company_name": "HAPPY GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003432": {
    "comapnyId": "7000003432",
    "company_name": "MRK GOLD LLP",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000044392": {
    "comapnyId": "7000044392",
    "company_name": "SORA JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069579": {
    "comapnyId": "7000069579",
    "company_name": "BALMUKUND GOLD",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000057630": {
    "comapnyId": "7000057630",
    "company_name": "ARIHANT JEWEL CRAFT",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007118": {
    "comapnyId": "7000007118",
    "company_name": "KINNOVA JEWELS PRIVATE LIMITED",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000010802": {
    "comapnyId": "7000010802",
    "company_name": "ZAYNA EXPORTS",
    "region": "region_6",
    "section": "sectionData_9",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053115": {
    "comapnyId": "7000053115",
    "company_name": "MUKESH & BROTHERS JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000001439": {
    "comapnyId": "7000001439",
    "company_name": "ARIHANT DIAMONDS ",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000065250": {
    "comapnyId": "7000065250",
    "company_name": "MERAKI JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000009731": {
    "comapnyId": "7000009731",
    "company_name": "KANAK JEWELS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011530": {
    "comapnyId": "7000011530",
    "company_name": "MOMAI ART PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000060392": {
    "comapnyId": "7000060392",
    "company_name": "GEE ESS EMM JEWELLERS PRIVATE LIMITED",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009325": {
    "comapnyId": "7000009325",
    "company_name": "RAJDHANI OVERSEAS ",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000007857": {
    "comapnyId": "7000007857",
    "company_name": "M.A. JEWELLERS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000002202": {
    "comapnyId": "7000002202",
    "company_name": "BHAWANI GOLD PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000068111": {
    "comapnyId": "7000068111",
    "company_name": "MANJUSHA JEWELS INDUSTRY INDIA PVT. LTD.",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003571": {
    "comapnyId": "7000003571",
    "company_name": "DIVYA JEWELS ",
    "region": "region_5",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069817": {
    "comapnyId": "7000069817",
    "company_name": "SHA MADANLAL DALICHAND",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000011109": {
    "comapnyId": "7000011109",
    "company_name": "VD JEWELS ARTISON PVT.LTD ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038422": {
    "comapnyId": "7000038422",
    "company_name": "MANYATA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000009953": {
    "comapnyId": "7000009953",
    "company_name": "CHHOTALAL DHANJIBHAI & SONS ",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000060552": {
    "comapnyId": "7000060552",
    "company_name": "BLUE GEMS&JEWELS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075377": {
    "comapnyId": "7000075377",
    "company_name": "MAGNIFIC GEMS",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012775": {
    "comapnyId": "7000012775",
    "company_name": "M L PITLIYA JEWELLERS ",
    "region": "region_4",
    "section": "sectionData_8",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066095": {
    "comapnyId": "7000066095",
    "company_name": "VIJAYKUMAR ABASAHEB BHOSALE",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070695": {
    "comapnyId": "7000070695",
    "company_name": "SHREEJI JEWELLERS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000076668": {
    "comapnyId": "7000076668",
    "company_name": "RIDDHI JEWEL",
    "region": "region_4",
    "section": "sectionData_3",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000078550": {
    "comapnyId": "7000078550",
    "company_name": "SALASAR JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000053151": {
    "comapnyId": "7000053151",
    "company_name": "DR JEWELS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000069826": {
    "comapnyId": "7000069826",
    "company_name": "TATVAM GOLD LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000063031": {
    "comapnyId": "7000063031",
    "company_name": "HEM FINE JEWELS LLP",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000035364": {
    "comapnyId": "7000035364",
    "company_name": "M V GOLD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000071504": {
    "comapnyId": "7000071504",
    "company_name": "JP ZAVERI LLP",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000003412": {
    "comapnyId": "7000003412",
    "company_name": "H.K. JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003497": {
    "comapnyId": "7000003497",
    "company_name": "HARI KRISHNA EXPORTS PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000034745": {
    "comapnyId": "7000034745",
    "company_name": "HIRANYA INDIA JEWEL PRIVATE LIMITED",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000058322": {
    "comapnyId": "7000058322",
    "company_name": "GOTI EXPORTS PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_10",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000004563": {
    "comapnyId": "7000004563",
    "company_name": "JAGDAMBA CHAINS PVT. LTD.",
    "region": "region_5",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000012314": {
    "comapnyId": "7000012314",
    "company_name": "RE JEWELS PVT. LTD. ",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000003614": {
    "comapnyId": "7000003614",
    "company_name": "VITHRAAG JEWELS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000070784": {
    "comapnyId": "7000070784",
    "company_name": "BHAGWAT SHANTI JEWELLERS PVT LTD",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000015511": {
    "comapnyId": "7000015511",
    "company_name": "SHREE GOLD JEWEL CREATOR ",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000075687": {
    "comapnyId": "7000075687",
    "company_name": "YOGI JEWELLERS",
    "region": "region_3",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066434": {
    "comapnyId": "7000066434",
    "company_name": "INDERLAL BALMUKAND GEMS & JEWELS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000052980": {
    "comapnyId": "7000052980",
    "company_name": "DHANLAKSHMI JEWELLERS,",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000038210": {
    "comapnyId": "7000038210",
    "company_name": "VS JEWELLERY WHOLESALER GLOBAL PVT. LTD",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 27,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000066436": {
    "comapnyId": "7000066436",
    "company_name": "ROSE JEWELS INDIA PVT. LTD.",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000051949": {
    "comapnyId": "7000051949",
    "company_name": "VAKPATI JEWELLERS LTD",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000052287": {
    "comapnyId": "7000052287",
    "company_name": "LAKSHMI GEMS AND JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 16,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000049060": {
    "comapnyId": "7000049060",
    "company_name": "SHREE NAKODA JEWELS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 12,
    "prime": "No",
    "primeAssure": "Yes"
  },
  "7000098704": {
    "comapnyId": "7000098704",
    "company_name": "IAGES- INDIAN ASSOCIATION FOR GOLD EXCELLENCE AND STANDARDS",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000050165": {
    "comapnyId": "7000050165",
    "company_name": "INDRA - DE BEERS INDIA PRIVATE LIMITED",
    "region": "region_2",
    "section": "sectionData_1",
    "area": 36,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000075340": {
    "comapnyId": "7000075340",
    "company_name": "SUNIL CHAINS AND ORNAMENTS",
    "region": "region_2",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000079927": {
    "comapnyId": "7000079927",
    "company_name": "PADMAVATHI JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000067606": {
    "comapnyId": "7000067606",
    "company_name": "SHREE RADHE DIAMONDS",
    "region": "region_1",
    "section": "sectionData_1",
    "area": 9,
    "prime": "Yes",
    "primeAssure": "No"
  },
  "7000073422": {
    "comapnyId": "7000073422",
    "company_name": "VRINDAVAN",
    "region": "region_6",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  },
  "7000053166": {
    "comapnyId": "7000053166",
    "company_name": "LOKHESHH JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 9,
    "prime": "No",
    "primeAssure": "No"
  }
};
export const setSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(newData);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

// console.log(data);

export const setNode = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const updateExhibitorData = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

window.setSellersBaseData = setSellersBaseData;
window.setNode = setNode;
